export const hotel_list = [
  
  
  {
    "id": 96365,
    "name": "Jetwing Vil Uyana, A Luxury Reserve",
    "city": "Sigiriya",
    "district": "Matale",
    "rating": 5,
    "images": [
      "http://pix5.agoda.net/hotelimages/96365/-1/00335f8e57cca2e0c6a073640af95038.jpg?s=312x&ca=9&ce=1",
      "http://pix1.agoda.net/hotelimages/963/96365/96365_16120914220049568352.jpg?s=312x&ca=13&ce=1",
      "http://pix3.agoda.net/hotelimages/963/96365/96365_16120914420049569478.jpg?s=312x&ca=6&ce=1",
      "http://pix1.agoda.net/hotelimages/963/96365/96365_16120914420049569479.jpg?s=312x&ca=6&ce=1",
      "http://pix2.agoda.net/hotelimages/963/96365/96365_16120914420049569481.jpg?s=312x&ca=6&ce=1"
    ],
    "primary_wellness_focus": "Spa / Leisure Wellness",
    "wellness_treatment_types": [
      "Stress Relief",
      "Relaxation",
      "Rejuvenation"
    ],
    "wellnessPackages": [
      "Spa Retreat",
      "Detox & Clensing Program",
      "Ayurveda & Holistic Healing",
      "Yoga & Meditation Center",
      "Rejuvenation & Burnout Recovery",
      "Nature Wellness and Eco Retreat"
    ],
    "hotel_Category": [
      "Luxury",
      "Boutique Luxury"
    ],
    "links": {
      "official_website": "",
      "agoda_source_url": "https://www.agoda.com/partners/partnersearch.aspx?hid=96365"
    },
    "property_features": {
      "adults_only": false,
      "family_friendly": false,
      "sustainability_certification": false,
      "primary_wellness_focus_property": true
    },
    "facilities": {
      "ayurveda_center": false,
      "spa": true,
      "yoga_pavilion": false,
      "meditation_hall": false,
      "fitness_center": true,
      "infinity_pool": true,
      "hydrotherapy_pool": false,
      "sauna": false,
      "steam_room": false,
      "jacuzzi": false,
      "salt_therapy_room": false,
      "wellness_library": false,
      "healing_garden": false,
      "herbal_garden": false,
      "walking_trails": true,
      "forest_bathing_area": true,
      "beachfront_wellness_space": false,
      "tea_plantation_walks": true
    },
    "activities_and_programs": {
      "outdoor_yoga_deck": false,
      "private_consultation_rooms": true,
      "sunrise_yoga": false,
      "sunset_yoga": false,
      "meditation_sessions": false,
      "breathwork": false,
      "mindfulness_workshops": false,
      "sound_healing": false,
      "chanting_sessions": false,
      "tai_chi": false,
      "qigong": false,
      "nature_walks": true,
      "forest_bathing": true,
      "bird_watching": true,
      "cooking_classes": true,
      "wellness_talks": false,
      "digital_detox_programs": false
    },
    "consultations_and_assessments": {
      "ayurvedic_doctor_consultation": false,
      "pulse_diagnosis": false,
      "lifestyle_assessment": false,
      "nutritional_consultation": false
    },
    "treatments_and_therapies": {
      "shirodhara": false,
      "shiro_abhyanga": false,
      "herbal_head_therapy": false,
      "abhyanga": false,
      "synchronised_abhyanga": false,
      "pinda_sweda": false,
      "udwardhana": false,
      "herbal_steam_bath": false,
      "sarvanga_dhara": false,
      "kati_basti": false,
      "greeva_basti": false,
      "janu_basti": false,
      "panchakarma": false,
      "vamana": false,
      "virechana": false,
      "basti": false,
      "nasya": false,
      "rakta_moksha": false
    },
    "segment_scores": {
      "holistic_healing_and_mindfulness_seekers": 3,
      "wellness_adventurers_and_nature_enthusiasts": 5,
      "luxury_rejuvenation_and_spa_retreaters": 5,
      "digital_detox_and_mental_wellness_travelers": 4,
      "cultural_and_ancestral_wellness_explorers": 5
    },
    "data_confidence": "Medium"
  },
  {
    "id": 216211,
    "name": "Jetwing Ayurveda Pavilions",
    "city": "Negombo",
    "district": "Gampaha",
    "rating": 4,
    "images": [
      "http://pix3.agoda.net/hotelimages/216/216211/216211_13061318540013029570.jpg?s=312x&ca=0&ce=1",
      "http://pix3.agoda.net/hotelimages/216/216211/216211_13061318540013029573.jpg?s=312x&ca=13&ce=1",
      "http://pix2.agoda.net/hotelimages/216/216211/216211_14052313430019547546.jpg?s=312x&ca=2&ce=1",
      "http://pix5.agoda.net/hotelimages/216/216211/216211_15123019440038815238.jpg?s=312x&ca=6&ce=1",
      "http://pix3.agoda.net/hotelimages/216/216211/216211_15123019450038815240.jpg?s=312x&ca=6&ce=1"
    ],
    "primary_wellness_focus": "Ayurveda / Holistic Healing",
    "wellness_treatment_types": [
      "Stress Relief",
      "Relaxation",
      "Rejuvenation",
      "Weight Loss",
      "Detox",
      "Panchakarma Program",
      "Mental Wellness",
      "Yoga Retreat"
    ],
    "wellnessPackages": [
      "Spa Retreat",
      "Detox & Clensing Program",
      "Ayurveda & Holistic Healing",
      "Yoga & Meditation Center",
      "Rejuvenation & Burnout Recovery",
      "Medical Wellness",
      "Coastal Wellness & Spa"
    ],
    "hotel_Category": [
      "Luxury",
      "Boutique Luxury"
    ],
    "links": {
      "official_website": "",
      "agoda_source_url": "https://www.agoda.com/partners/partnersearch.aspx?hid=216211"
    },
    "property_features": {
      "adults_only": false,
      "family_friendly": false,
      "sustainability_certification": false,
      "primary_wellness_focus_property": true
    },
    "facilities": {
      "ayurveda_center": true,
      "spa": true,
      "yoga_pavilion": true,
      "meditation_hall": false,
      "fitness_center": false,
      "infinity_pool": true,
      "hydrotherapy_pool": false,
      "sauna": false,
      "steam_room": true,
      "jacuzzi": false,
      "salt_therapy_room": false,
      "wellness_library": false,
      "healing_garden": false,
      "herbal_garden": true,
      "walking_trails": true,
      "forest_bathing_area": true,
      "beachfront_wellness_space": true,
      "tea_plantation_walks": false
    },
    "activities_and_programs": {
      "outdoor_yoga_deck": true,
      "private_consultation_rooms": true,
      "sunrise_yoga": true,
      "sunset_yoga": true,
      "meditation_sessions": false,
      "breathwork": false,
      "mindfulness_workshops": false,
      "sound_healing": false,
      "chanting_sessions": false,
      "tai_chi": false,
      "qigong": false,
      "nature_walks": true,
      "forest_bathing": true,
      "bird_watching": true,
      "cooking_classes": false,
      "wellness_talks": true,
      "digital_detox_programs": false
    },
    "consultations_and_assessments": {
      "ayurvedic_doctor_consultation": true,
      "pulse_diagnosis": true,
      "lifestyle_assessment": true,
      "nutritional_consultation": true
    },
    "treatments_and_therapies": {
      "shirodhara": true,
      "shiro_abhyanga": true,
      "herbal_head_therapy": true,
      "abhyanga": true,
      "synchronised_abhyanga": false,
      "pinda_sweda": false,
      "udwardhana": false,
      "herbal_steam_bath": true,
      "sarvanga_dhara": false,
      "kati_basti": false,
      "greeva_basti": false,
      "janu_basti": false,
      "panchakarma": true,
      "vamana": false,
      "virechana": true,
      "basti": true,
      "nasya": true,
      "rakta_moksha": false
    },
    "segment_scores": {
      "holistic_healing_and_mindfulness_seekers": 5,
      "wellness_adventurers_and_nature_enthusiasts": 5,
      "luxury_rejuvenation_and_spa_retreaters": 5,
      "digital_detox_and_mental_wellness_travelers": 5,
      "cultural_and_ancestral_wellness_explorers": 4
    },
    "data_confidence": "Medium"
  },
  {
    "id": 240329,
    "name": "Uga Ulagalla - Anuradhapura",
    "city": "Anuradhapura",
    "district": "Anuradhapura",
    "rating": 5,
    "images": [
      "http://pix1.agoda.net/hotelimages/240329/0/ac6b6b815a5acef377dbf61b1b6a44c4.jpg?s=312x&ce=2",
      "http://pix2.agoda.net/hotelimages/240/240329/240329_16072715510044988368.jpg?s=312x&ca=13&ce=1",
      "http://pix2.agoda.net/hotelimages/240/240329/240329_130104150638655.jpg?s=312x&ca=0&ce=1",
      "http://pix2.agoda.net/hotelimages/240/240329/240329_16072715510044988356.jpg?s=312x&ca=6&ce=1",
      "http://pix4.agoda.net/hotelimages/240/240329/240329_16072715510044988358.jpg?s=312x&ca=6&ce=1"
    ],
    "primary_wellness_focus": "Spa / Leisure Wellness",
    "wellness_treatment_types": [
      "Stress Relief",
      "Relaxation",
      "Rejuvenation"
    ],
    "wellnessPackages": [
      "Spa Retreat",
      "Ayurveda & Holistic Healing",
      "Rejuvenation & Burnout Recovery",
      "Nature Wellness and Eco Retreat"
    ],
    "hotel_Category": [
      "Luxury",
      "Boutique Luxury"
    ],
    "links": {
      "official_website": "",
      "agoda_source_url": "https://www.agoda.com/partners/partnersearch.aspx?hid=240329"
    },
    "property_features": {
      "adults_only": false,
      "family_friendly": false,
      "sustainability_certification": false,
      "primary_wellness_focus_property": true
    },
    "facilities": {
      "ayurveda_center": false,
      "spa": true,
      "yoga_pavilion": false,
      "meditation_hall": false,
      "fitness_center": true,
      "infinity_pool": true,
      "hydrotherapy_pool": false,
      "sauna": true,
      "steam_room": false,
      "jacuzzi": false,
      "salt_therapy_room": false,
      "wellness_library": false,
      "healing_garden": false,
      "herbal_garden": false,
      "walking_trails": false,
      "forest_bathing_area": false,
      "beachfront_wellness_space": false,
      "tea_plantation_walks": true
    },
    "activities_and_programs": {
      "outdoor_yoga_deck": false,
      "private_consultation_rooms": true,
      "sunrise_yoga": false,
      "sunset_yoga": false,
      "meditation_sessions": false,
      "breathwork": false,
      "mindfulness_workshops": false,
      "sound_healing": false,
      "chanting_sessions": false,
      "tai_chi": false,
      "qigong": false,
      "nature_walks": false,
      "forest_bathing": false,
      "bird_watching": false,
      "cooking_classes": true,
      "wellness_talks": false,
      "digital_detox_programs": false
    },
    "consultations_and_assessments": {
      "ayurvedic_doctor_consultation": false,
      "pulse_diagnosis": false,
      "lifestyle_assessment": false,
      "nutritional_consultation": false
    },
    "treatments_and_therapies": {
      "shirodhara": false,
      "shiro_abhyanga": false,
      "herbal_head_therapy": false,
      "abhyanga": false,
      "synchronised_abhyanga": false,
      "pinda_sweda": false,
      "udwardhana": false,
      "herbal_steam_bath": false,
      "sarvanga_dhara": false,
      "kati_basti": false,
      "greeva_basti": false,
      "janu_basti": false,
      "panchakarma": false,
      "vamana": false,
      "virechana": false,
      "basti": false,
      "nasya": false,
      "rakta_moksha": false
    },
    "segment_scores": {
      "holistic_healing_and_mindfulness_seekers": 3,
      "wellness_adventurers_and_nature_enthusiasts": 2,
      "luxury_rejuvenation_and_spa_retreaters": 5,
      "digital_detox_and_mental_wellness_travelers": 4,
      "cultural_and_ancestral_wellness_explorers": 5
    },
    "data_confidence": "Medium"
  },
  {
    "id": 245856,
    "name": "Ayugiri Ayurveda Wellness Resort Sigiriya ",
    "city": "Sigiriya",
    "district": "Matale",
    "rating": 5,
    "images": [
      "http://pix3.agoda.net/hotelimages/245856/-1/378835068a917633ac94ba37e36f3030.jpg?s=312x&ce=0",
      "http://pix2.agoda.net/hotelimages/245856/-1/8135ac9417d4126de8d856401e4e5943.jpg?s=312x&ce=0",
      "http://pix1.agoda.net/hotelimages/245856/-1/e8f286a61b913f23df1779ae0f4afad1.jpg?s=312x&ce=0",
      "http://pix3.agoda.net/hotelimages/245856/-1/3e7f1c09c0163786c2a4118c69bd4c9d.jpg?s=312x&ce=0",
      "http://pix2.agoda.net/hotelimages/245856/-1/1dfd79b3c2803b2563b34580f32ac018.jpg?s=312x&ce=0"
    ],
    "primary_wellness_focus": "Ayurveda / Holistic Healing",
    "wellness_treatment_types": [
      "Stress Relief",
      "Relaxation",
      "Rejuvenation",
      "Weight Loss",
      "Detox",
      "Panchakarma Program",
      "Burnout Recovery",
      "Mental Wellness",
      "Yoga Retreat",
      "Meditation Retreat"
    ],
    "wellnessPackages": [
      "Spa Retreat",
      "Detox & Clensing Program",
      "Ayurveda & Holistic Healing",
      "Yoga & Meditation Center",
      "Rejuvenation & Burnout Recovery",
      "Medical Wellness",
      "Nature Wellness and Eco Retreat"
    ],
    "hotel_Category": [
      "Luxury",
      "Boutique Luxury"
    ],
    "links": {
      "official_website": "",
      "agoda_source_url": "https://www.agoda.com/partners/partnersearch.aspx?hid=245856"
    },
    "property_features": {
      "adults_only": false,
      "family_friendly": false,
      "sustainability_certification": false,
      "primary_wellness_focus_property": true
    },
    "facilities": {
      "ayurveda_center": true,
      "spa": true,
      "yoga_pavilion": true,
      "meditation_hall": true,
      "fitness_center": false,
      "infinity_pool": true,
      "hydrotherapy_pool": false,
      "sauna": false,
      "steam_room": true,
      "jacuzzi": false,
      "salt_therapy_room": false,
      "wellness_library": false,
      "healing_garden": false,
      "herbal_garden": true,
      "walking_trails": true,
      "forest_bathing_area": true,
      "beachfront_wellness_space": true,
      "tea_plantation_walks": true
    },
    "activities_and_programs": {
      "outdoor_yoga_deck": true,
      "private_consultation_rooms": true,
      "sunrise_yoga": true,
      "sunset_yoga": true,
      "meditation_sessions": true,
      "breathwork": false,
      "mindfulness_workshops": true,
      "sound_healing": false,
      "chanting_sessions": false,
      "tai_chi": false,
      "qigong": false,
      "nature_walks": true,
      "forest_bathing": true,
      "bird_watching": true,
      "cooking_classes": true,
      "wellness_talks": true,
      "digital_detox_programs": false
    },
    "consultations_and_assessments": {
      "ayurvedic_doctor_consultation": true,
      "pulse_diagnosis": true,
      "lifestyle_assessment": true,
      "nutritional_consultation": true
    },
    "treatments_and_therapies": {
      "shirodhara": true,
      "shiro_abhyanga": true,
      "herbal_head_therapy": true,
      "abhyanga": true,
      "synchronised_abhyanga": false,
      "pinda_sweda": false,
      "udwardhana": false,
      "herbal_steam_bath": true,
      "sarvanga_dhara": false,
      "kati_basti": false,
      "greeva_basti": false,
      "janu_basti": false,
      "panchakarma": true,
      "vamana": false,
      "virechana": true,
      "basti": true,
      "nasya": true,
      "rakta_moksha": false
    },
    "segment_scores": {
      "holistic_healing_and_mindfulness_seekers": 5,
      "wellness_adventurers_and_nature_enthusiasts": 5,
      "luxury_rejuvenation_and_spa_retreaters": 5,
      "digital_detox_and_mental_wellness_travelers": 5,
      "cultural_and_ancestral_wellness_explorers": 5
    },
    "data_confidence": "Medium"
  },
  {
    "id": 262741,
    "name": "Siddhalepa Ayurveda Resort - All Meals Ayurveda Treatment and Yoga",
    "city": "Wadduwa",
    "district": "Kalutara",
    "rating": 4,
    "images": [
      "http://pix1.agoda.net/hotelimages/262741/0/b84fe59a1e52c47569711e6e41d337de.jpg?s=312x&ce=3",
      "http://pix4.agoda.net/hotelimages/262/262741/262741_120216164834531.jpg?s=312x&ca=13&ce=1",
      "http://pix4.agoda.net/hotelimages/262/262741/262741_111223151322374.jpg?s=312x&ca=0&ce=1",
      "http://pix3.agoda.net/hotelimages/262/262741/262741_111223151341375.jpg?s=312x&ca=0&ce=1",
      "http://pix4.agoda.net/hotelimages/262/262741/262741_111223151646004.jpg?s=312x&ca=0&ce=1"
    ],
    "primary_wellness_focus": "Ayurveda / Holistic Healing",
    "wellness_treatment_types": [
      "Stress Relief",
      "Relaxation",
      "Rejuvenation",
      "Weight Loss",
      "Detox",
      "Panchakarma Program",
      "Mental Wellness",
      "Yoga Retreat"
    ],
    "wellnessPackages": [
      "Spa Retreat",
      "Detox & Clensing Program",
      "Ayurveda & Holistic Healing",
      "Yoga & Meditation Center",
      "Rejuvenation & Burnout Recovery",
      "Medical Wellness",
      "Coastal Wellness & Spa"
    ],
    "hotel_Category": [
      "Boutique",
      "Eco Wellness"
    ],
    "links": {
      "official_website": "",
      "agoda_source_url": "https://www.agoda.com/partners/partnersearch.aspx?hid=262741"
    },
    "property_features": {
      "adults_only": false,
      "family_friendly": false,
      "sustainability_certification": false,
      "primary_wellness_focus_property": true
    },
    "facilities": {
      "ayurveda_center": true,
      "spa": true,
      "yoga_pavilion": true,
      "meditation_hall": false,
      "fitness_center": true,
      "infinity_pool": true,
      "hydrotherapy_pool": false,
      "sauna": true,
      "steam_room": true,
      "jacuzzi": true,
      "salt_therapy_room": false,
      "wellness_library": false,
      "healing_garden": false,
      "herbal_garden": true,
      "walking_trails": true,
      "forest_bathing_area": true,
      "beachfront_wellness_space": true,
      "tea_plantation_walks": true
    },
    "activities_and_programs": {
      "outdoor_yoga_deck": true,
      "private_consultation_rooms": true,
      "sunrise_yoga": true,
      "sunset_yoga": true,
      "meditation_sessions": false,
      "breathwork": false,
      "mindfulness_workshops": false,
      "sound_healing": false,
      "chanting_sessions": false,
      "tai_chi": false,
      "qigong": false,
      "nature_walks": true,
      "forest_bathing": true,
      "bird_watching": true,
      "cooking_classes": true,
      "wellness_talks": true,
      "digital_detox_programs": false
    },
    "consultations_and_assessments": {
      "ayurvedic_doctor_consultation": true,
      "pulse_diagnosis": true,
      "lifestyle_assessment": true,
      "nutritional_consultation": true
    },
    "treatments_and_therapies": {
      "shirodhara": true,
      "shiro_abhyanga": true,
      "herbal_head_therapy": true,
      "abhyanga": true,
      "synchronised_abhyanga": false,
      "pinda_sweda": false,
      "udwardhana": false,
      "herbal_steam_bath": true,
      "sarvanga_dhara": false,
      "kati_basti": false,
      "greeva_basti": false,
      "janu_basti": false,
      "panchakarma": true,
      "vamana": false,
      "virechana": true,
      "basti": true,
      "nasya": true,
      "rakta_moksha": false
    },
    "segment_scores": {
      "holistic_healing_and_mindfulness_seekers": 5,
      "wellness_adventurers_and_nature_enthusiasts": 5,
      "luxury_rejuvenation_and_spa_retreaters": 5,
      "digital_detox_and_mental_wellness_travelers": 5,
      "cultural_and_ancestral_wellness_explorers": 4
    },
    "data_confidence": "Medium"
  },
  {
    "id": 274393,
    "name": "Glenross Living",
    "city": "Kalutara",
    "district": "Kalutara",
    "rating": 3,
    "images": [
      "http://pix1.agoda.net/hotelimages/274393/-1/f04af8702b1e1a61a6620096d56226c6.jpg?s=312x&ce=0",
      "http://pix5.agoda.net/hotelimages/274393/-1/af5c4d90679424611eda9f50987a9b13.jpg?s=312x&ca=25&ce=0",
      "http://pix5.agoda.net/hotelimages/274393/-1/d5bb8b7a670af8c8c938786b2b43f3cf.jpg?s=312x&ca=25&ce=0",
      "http://pix4.agoda.net/hotelimages/274393/-1/90a2f264ef591c74dfe7af95796a9d0a.jpg?s=312x&ca=25&ce=0",
      "http://pix3.agoda.net/hotelimages/274393/-1/f6edf83a9c52b78c0a1423ef7165f6f1.jpg?s=312x&ca=25&ce=0"
    ],
    "primary_wellness_focus": "Nature Wellness / Eco Retreat",
    "wellness_treatment_types": [
      "Stress Relief",
      "Relaxation",
      "Rejuvenation"
    ],
    "wellnessPackages": [
      "Spa Retreat",
      "Detox & Clensing Program",
      "Ayurveda & Holistic Healing",
      "Yoga & Meditation Center",
      "Rejuvenation & Burnout Recovery",
      "Nature Wellness and Eco Retreat"
    ],
    "hotel_Category": [
      "Boutique",
      "Eco Wellness"
    ],
    "links": {
      "official_website": "",
      "agoda_source_url": "https://www.agoda.com/partners/partnersearch.aspx?hid=274393"
    },
    "property_features": {
      "adults_only": false,
      "family_friendly": false,
      "sustainability_certification": false,
      "primary_wellness_focus_property": true
    },
    "facilities": {
      "ayurveda_center": false,
      "spa": true,
      "yoga_pavilion": false,
      "meditation_hall": false,
      "fitness_center": false,
      "infinity_pool": true,
      "hydrotherapy_pool": false,
      "sauna": false,
      "steam_room": false,
      "jacuzzi": false,
      "salt_therapy_room": false,
      "wellness_library": false,
      "healing_garden": false,
      "herbal_garden": false,
      "walking_trails": true,
      "forest_bathing_area": true,
      "beachfront_wellness_space": false,
      "tea_plantation_walks": true
    },
    "activities_and_programs": {
      "outdoor_yoga_deck": false,
      "private_consultation_rooms": true,
      "sunrise_yoga": false,
      "sunset_yoga": false,
      "meditation_sessions": false,
      "breathwork": false,
      "mindfulness_workshops": false,
      "sound_healing": false,
      "chanting_sessions": false,
      "tai_chi": false,
      "qigong": false,
      "nature_walks": true,
      "forest_bathing": true,
      "bird_watching": true,
      "cooking_classes": true,
      "wellness_talks": false,
      "digital_detox_programs": false
    },
    "consultations_and_assessments": {
      "ayurvedic_doctor_consultation": false,
      "pulse_diagnosis": false,
      "lifestyle_assessment": false,
      "nutritional_consultation": false
    },
    "treatments_and_therapies": {
      "shirodhara": false,
      "shiro_abhyanga": false,
      "herbal_head_therapy": false,
      "abhyanga": false,
      "synchronised_abhyanga": false,
      "pinda_sweda": false,
      "udwardhana": false,
      "herbal_steam_bath": false,
      "sarvanga_dhara": false,
      "kati_basti": false,
      "greeva_basti": false,
      "janu_basti": false,
      "panchakarma": false,
      "vamana": false,
      "virechana": false,
      "basti": false,
      "nasya": false,
      "rakta_moksha": false
    },
    "segment_scores": {
      "holistic_healing_and_mindfulness_seekers": 3,
      "wellness_adventurers_and_nature_enthusiasts": 5,
      "luxury_rejuvenation_and_spa_retreaters": 5,
      "digital_detox_and_mental_wellness_travelers": 5,
      "cultural_and_ancestral_wellness_explorers": 2
    },
    "data_confidence": "Medium"
  },
  {
    "id": 290153,
    "name": "Jetwing Lagoon Wellness, A Luxury Reserve - Adults Only",
    "city": "Negombo",
    "district": "Moneragala",
    "rating": 5,
    "images": [
      "http://pix5.agoda.net/hotelimages/290153/-1/36ee1d2b31078f540db6854a31854bf5.jpg?s=312x&ca=7&ce=1",
      "http://pix4.agoda.net/hotelimages/290153/-1/97b427b153551894b2bd825844621f3c.jpg?s=312x&ce=0",
      "http://pix5.agoda.net/hotelimages/290/290153/290153_17052617510053265930.jpg?s=312x&ca=6&ce=1",
      "http://pix4.agoda.net/hotelimages/290153/-1/5c7cea9ea31db16c5970e4c4b6cc4241.jpg?s=312x&ca=10&ce=1",
      "http://pix3.agoda.net/hotelimages/290153/-1/900ec23d16c31fe5919311e49cc26b01.jpg?s=312x&ca=10&ce=1"
    ],
    "primary_wellness_focus": "Wellness Retreat / Rejuvenation",
    "wellness_treatment_types": [
      "Stress Relief",
      "Relaxation",
      "Rejuvenation",
      "Burnout Recovery",
      "Mental Wellness",
      "Yoga Retreat",
      "Meditation Retreat"
    ],
    "wellnessPackages": [
      "Spa Retreat",
      "Detox & Clensing Program",
      "Ayurveda & Holistic Healing",
      "Yoga & Meditation Center",
      "Rejuvenation & Burnout Recovery",
      "Medical Wellness",
      "Coastal Wellness & Spa"
    ],
    "hotel_Category": [
      "Luxury",
      "Boutique Luxury"
    ],
    "links": {
      "official_website": "",
      "agoda_source_url": "https://www.agoda.com/partners/partnersearch.aspx?hid=290153"
    },
    "property_features": {
      "adults_only": true,
      "family_friendly": false,
      "sustainability_certification": false,
      "primary_wellness_focus_property": true
    },
    "facilities": {
      "ayurveda_center": false,
      "spa": true,
      "yoga_pavilion": true,
      "meditation_hall": true,
      "fitness_center": true,
      "infinity_pool": true,
      "hydrotherapy_pool": false,
      "sauna": false,
      "steam_room": false,
      "jacuzzi": false,
      "salt_therapy_room": false,
      "wellness_library": false,
      "healing_garden": false,
      "herbal_garden": false,
      "walking_trails": true,
      "forest_bathing_area": true,
      "beachfront_wellness_space": true,
      "tea_plantation_walks": true
    },
    "activities_and_programs": {
      "outdoor_yoga_deck": true,
      "private_consultation_rooms": true,
      "sunrise_yoga": true,
      "sunset_yoga": true,
      "meditation_sessions": true,
      "breathwork": false,
      "mindfulness_workshops": true,
      "sound_healing": false,
      "chanting_sessions": false,
      "tai_chi": false,
      "qigong": false,
      "nature_walks": true,
      "forest_bathing": true,
      "bird_watching": true,
      "cooking_classes": true,
      "wellness_talks": true,
      "digital_detox_programs": false
    },
    "consultations_and_assessments": {
      "ayurvedic_doctor_consultation": false,
      "pulse_diagnosis": false,
      "lifestyle_assessment": true,
      "nutritional_consultation": false
    },
    "treatments_and_therapies": {
      "shirodhara": false,
      "shiro_abhyanga": false,
      "herbal_head_therapy": false,
      "abhyanga": false,
      "synchronised_abhyanga": false,
      "pinda_sweda": false,
      "udwardhana": false,
      "herbal_steam_bath": false,
      "sarvanga_dhara": false,
      "kati_basti": false,
      "greeva_basti": false,
      "janu_basti": false,
      "panchakarma": false,
      "vamana": false,
      "virechana": false,
      "basti": false,
      "nasya": false,
      "rakta_moksha": false
    },
    "segment_scores": {
      "holistic_healing_and_mindfulness_seekers": 5,
      "wellness_adventurers_and_nature_enthusiasts": 5,
      "luxury_rejuvenation_and_spa_retreaters": 5,
      "digital_detox_and_mental_wellness_travelers": 5,
      "cultural_and_ancestral_wellness_explorers": 2
    },
    "data_confidence": "Medium"
  },
  {
    "id": 301820,
    "name": "The Plantation Villa",
    "city": "Kalutara",
    "district": "Kalutara",
    "rating": 3,
    "images": [
      "http://pix5.agoda.net/hotelimages/301820/-1/9fd44dd172dd805b6ae1244071d0b194.jpg?s=312x&ca=13&ce=1",
      "http://pix4.agoda.net/hotelimages/301/301820/301820_13120617580017839012.jpg?s=312x&ca=2&ce=1",
      "http://pix2.agoda.net/hotelimages/301/301820/301820_16030123130040369386.jpg?s=312x&ca=6&ce=1",
      "http://pix4.agoda.net/hotelimages/301/301820/301820_16030123130040369389.jpg?s=312x&ca=6&ce=1"
    ],
    "primary_wellness_focus": "Spa / Leisure Wellness",
    "wellness_treatment_types": [
      "Stress Relief",
      "Relaxation",
      "Rejuvenation"
    ],
    "wellnessPackages": [
      "Spa Retreat",
      "Detox & Clensing Program",
      "Ayurveda & Holistic Healing",
      "Yoga & Meditation Center",
      "Rejuvenation & Burnout Recovery",
      "Medical Wellness"
    ],
    "hotel_Category": [
      "Boutique",
      "Eco Wellness"
    ],
    "links": {
      "official_website": "",
      "agoda_source_url": "https://www.agoda.com/partners/partnersearch.aspx?hid=301820"
    },
    "property_features": {
      "adults_only": false,
      "family_friendly": false,
      "sustainability_certification": false,
      "primary_wellness_focus_property": true
    },
    "facilities": {
      "ayurveda_center": false,
      "spa": true,
      "yoga_pavilion": false,
      "meditation_hall": false,
      "fitness_center": false,
      "infinity_pool": true,
      "hydrotherapy_pool": false,
      "sauna": true,
      "steam_room": true,
      "jacuzzi": false,
      "salt_therapy_room": false,
      "wellness_library": false,
      "healing_garden": false,
      "herbal_garden": false,
      "walking_trails": true,
      "forest_bathing_area": true,
      "beachfront_wellness_space": false,
      "tea_plantation_walks": true
    },
    "activities_and_programs": {
      "outdoor_yoga_deck": false,
      "private_consultation_rooms": true,
      "sunrise_yoga": false,
      "sunset_yoga": false,
      "meditation_sessions": false,
      "breathwork": false,
      "mindfulness_workshops": false,
      "sound_healing": false,
      "chanting_sessions": false,
      "tai_chi": false,
      "qigong": false,
      "nature_walks": true,
      "forest_bathing": true,
      "bird_watching": true,
      "cooking_classes": true,
      "wellness_talks": false,
      "digital_detox_programs": false
    },
    "consultations_and_assessments": {
      "ayurvedic_doctor_consultation": false,
      "pulse_diagnosis": false,
      "lifestyle_assessment": false,
      "nutritional_consultation": true
    },
    "treatments_and_therapies": {
      "shirodhara": false,
      "shiro_abhyanga": false,
      "herbal_head_therapy": false,
      "abhyanga": false,
      "synchronised_abhyanga": false,
      "pinda_sweda": false,
      "udwardhana": false,
      "herbal_steam_bath": true,
      "sarvanga_dhara": false,
      "kati_basti": false,
      "greeva_basti": false,
      "janu_basti": false,
      "panchakarma": false,
      "vamana": false,
      "virechana": false,
      "basti": false,
      "nasya": false,
      "rakta_moksha": false
    },
    "segment_scores": {
      "holistic_healing_and_mindfulness_seekers": 3,
      "wellness_adventurers_and_nature_enthusiasts": 2,
      "luxury_rejuvenation_and_spa_retreaters": 5,
      "digital_detox_and_mental_wellness_travelers": 5,
      "cultural_and_ancestral_wellness_explorers": 2
    },
    "data_confidence": "Medium"
  },
  {
    "id": 302752,
    "name": "Uga Jungle Beach - Trincomalee",
    "city": "Trincomalee",
    "district": "Trincomalee",
    "rating": 5,
    "images": [
      "http://pix2.agoda.net/hotelimages/302752/-1/d3cb803ee55d5127b075e1164c39aca0.jpg?s=312x&ce=0",
      "http://pix2.agoda.net/hotelimages/302752/-1/1c237a2fdde6bc88e3a7e890ad95994b.jpg?s=312x&ce=0",
      "http://pix2.agoda.net/hotelimages/302752/-1/5fd91eb26090bbb9802f5740b1c76bd5.png?s=312x&ce=0",
      "http://pix4.agoda.net/hotelimages/302752/-1/077e5a3576751c4c8a46c3629072db7b.jpg?s=312x&ce=0",
      "http://pix1.agoda.net/hotelimages/302752/-1/67d8f5bb352e373282bf463809e3e07c.jpg?s=312x&ce=0"
    ],
    "primary_wellness_focus": "Nature Wellness / Eco Retreat",
    "wellness_treatment_types": [
      "Relaxation",
      "Rejuvenation"
    ],
    "wellnessPackages": [
      "Spa Retreat",
      "Ayurveda & Holistic Healing",
      "Yoga & Meditation Center",
      "Rejuvenation & Burnout Recovery",
      "Nature Wellness and Eco Retreat",
      "Coastal Wellness & Spa"
    ],
    "hotel_Category": [
      "Luxury",
      "Boutique Luxury"
    ],
    "links": {
      "official_website": "",
      "agoda_source_url": "https://www.agoda.com/partners/partnersearch.aspx?hid=302752"
    },
    "property_features": {
      "adults_only": false,
      "family_friendly": false,
      "sustainability_certification": false,
      "primary_wellness_focus_property": true
    },
    "facilities": {
      "ayurveda_center": false,
      "spa": true,
      "yoga_pavilion": false,
      "meditation_hall": false,
      "fitness_center": false,
      "infinity_pool": true,
      "hydrotherapy_pool": false,
      "sauna": false,
      "steam_room": false,
      "jacuzzi": false,
      "salt_therapy_room": false,
      "wellness_library": false,
      "healing_garden": false,
      "herbal_garden": false,
      "walking_trails": true,
      "forest_bathing_area": true,
      "beachfront_wellness_space": true,
      "tea_plantation_walks": true
    },
    "activities_and_programs": {
      "outdoor_yoga_deck": false,
      "private_consultation_rooms": true,
      "sunrise_yoga": false,
      "sunset_yoga": false,
      "meditation_sessions": false,
      "breathwork": false,
      "mindfulness_workshops": false,
      "sound_healing": false,
      "chanting_sessions": false,
      "tai_chi": false,
      "qigong": false,
      "nature_walks": true,
      "forest_bathing": true,
      "bird_watching": true,
      "cooking_classes": true,
      "wellness_talks": false,
      "digital_detox_programs": false
    },
    "consultations_and_assessments": {
      "ayurvedic_doctor_consultation": false,
      "pulse_diagnosis": false,
      "lifestyle_assessment": false,
      "nutritional_consultation": false
    },
    "treatments_and_therapies": {
      "shirodhara": false,
      "shiro_abhyanga": false,
      "herbal_head_therapy": false,
      "abhyanga": false,
      "synchronised_abhyanga": false,
      "pinda_sweda": false,
      "udwardhana": false,
      "herbal_steam_bath": false,
      "sarvanga_dhara": false,
      "kati_basti": false,
      "greeva_basti": false,
      "janu_basti": false,
      "panchakarma": false,
      "vamana": false,
      "virechana": false,
      "basti": false,
      "nasya": false,
      "rakta_moksha": false
    },
    "segment_scores": {
      "holistic_healing_and_mindfulness_seekers": 3,
      "wellness_adventurers_and_nature_enthusiasts": 5,
      "luxury_rejuvenation_and_spa_retreaters": 5,
      "digital_detox_and_mental_wellness_travelers": 5,
      "cultural_and_ancestral_wellness_explorers": 2
    },
    "data_confidence": "Medium"
  },
  {
    "id": 406820,
    "name": "Roman Lake Ayurveda Boutique Resort",
    "city": "Bentota",
    "district": "Galle",
    "rating": 4,
    "images": [
      'http://pix1.agoda.net/hotelimages/406/406820/406820_16101014120047579559.jpg?s=312x&ca=6&ce=1',
      'http://pix3.agoda.net/hotelimages/406/406820/406820_14091913440022268657.jpg?s=312x&ca=13&ce=1',
      'http://pix4.agoda.net/hotelimages/406/406820/406820_14091913440022268656.jpg?s=312x&ca=13&ce=1',
      'http://pix3.agoda.net/hotelimages/406/406820/406820_15080711470033844459.jpg?s=312x&ca=5&ce=1',
      'http://pix1.agoda.net/hotelimages/406/406820/406820_15080711470033844462.jpg?s=312x&ca=5&ce=1'
    ],
    "primary_wellness_focus": "Ayurveda / Holistic Healing",
    "wellness_treatment_types": [
      "Stress Relief",
      "Relaxation",
      "Rejuvenation",
      "Weight Loss",
      "Detox",
      "Panchakarma Program",
      "Mental Wellness",
      "Yoga Retreat"
    ],
    "wellnessPackages": [
      "Spa Retreat",
      "Detox & Clensing Program",
      "Ayurveda & Holistic Healing",
      "Yoga & Meditation Center",
      "Rejuvenation & Burnout Recovery",
      "Medical Wellness",
      "Nature Wellness and Eco Retreat",
      "Coastal Wellness & Spa"
    ],
    "hotel_Category": [
      "Boutique",
      "Eco Wellness"
    ],
    "links": {
      "official_website": "",
      "agoda_source_url": "https://www.agoda.com/partners/partnersearch.aspx?hid=406820"
    },
    "property_features": {
      "adults_only": false,
      "family_friendly": false,
      "sustainability_certification": false,
      "primary_wellness_focus_property": true
    },
    "facilities": {
      "ayurveda_center": true,
      "spa": true,
      "yoga_pavilion": true,
      "meditation_hall": false,
      "fitness_center": false,
      "infinity_pool": true,
      "hydrotherapy_pool": false,
      "sauna": true,
      "steam_room": true,
      "jacuzzi": true,
      "salt_therapy_room": false,
      "wellness_library": false,
      "healing_garden": true,
      "herbal_garden": true,
      "walking_trails": true,
      "forest_bathing_area": true,
      "beachfront_wellness_space": true,
      "tea_plantation_walks": true
    },
    "activities_and_programs": {
      "outdoor_yoga_deck": true,
      "private_consultation_rooms": true,
      "sunrise_yoga": true,
      "sunset_yoga": true,
      "meditation_sessions": false,
      "breathwork": false,
      "mindfulness_workshops": false,
      "sound_healing": false,
      "chanting_sessions": false,
      "tai_chi": false,
      "qigong": false,
      "nature_walks": true,
      "forest_bathing": true,
      "bird_watching": true,
      "cooking_classes": false,
      "wellness_talks": true,
      "digital_detox_programs": false
    },
    "consultations_and_assessments": {
      "ayurvedic_doctor_consultation": true,
      "pulse_diagnosis": true,
      "lifestyle_assessment": true,
      "nutritional_consultation": true
    },
    "treatments_and_therapies": {
      "shirodhara": true,
      "shiro_abhyanga": true,
      "herbal_head_therapy": true,
      "abhyanga": true,
      "synchronised_abhyanga": false,
      "pinda_sweda": false,
      "udwardhana": false,
      "herbal_steam_bath": true,
      "sarvanga_dhara": false,
      "kati_basti": false,
      "greeva_basti": false,
      "janu_basti": false,
      "panchakarma": true,
      "vamana": false,
      "virechana": true,
      "basti": true,
      "nasya": true,
      "rakta_moksha": false
    },
    "segment_scores": {
      "holistic_healing_and_mindfulness_seekers": 5,
      "wellness_adventurers_and_nature_enthusiasts": 5,
      "luxury_rejuvenation_and_spa_retreaters": 5,
      "digital_detox_and_mental_wellness_travelers": 5,
      "cultural_and_ancestral_wellness_explorers": 4
    },
    "data_confidence": "Medium"
  },
  {
    "id": 489147,
    "name": "Aliya Resort & Spa - Thema Collection",
    "city": "Sigiriya",
    "district": "Matale",
    "rating": 5,
    "images": [
      "http://pix3.agoda.net/hotelimages/489/489147/489147_15060311530028316943.jpg?s=312x&ca=4&ce=1",
      "http://pix5.agoda.net/hotelimages/489/489147/489147_15053100590028096369.jpg?s=312x&ca=13&ce=1",
      "http://pix1.agoda.net/hotelimages/489/489147/489147_15060311530028316945.jpg?s=312x&ca=4&ce=1",
      "http://pix2.agoda.net/hotelimages/489/489147/489147_15060311530028316946.jpg?s=312x&ca=4&ce=1",
      "http://pix2.agoda.net/hotelimages/489/489147/489147_15060311530028316948.jpg?s=312x&ca=4&ce=1"
    ],
    "primary_wellness_focus": "Spa / Leisure Wellness",
    "wellness_treatment_types": [
      "Relaxation",
      "Rejuvenation"
    ],
    "wellnessPackages": [
      "Spa Retreat",
      "Detox & Clensing Program",
      "Ayurveda & Holistic Healing",
      "Yoga & Meditation Center",
      "Rejuvenation & Burnout Recovery",
      "Nature Wellness and Eco Retreat"
    ],
    "hotel_Category": [
      "Luxury",
      "Boutique Luxury"
    ],
    "links": {
      "official_website": "https://www.themacollection.com/aliya-resort/",
      "agoda_source_url": "https://www.agoda.com/partners/partnersearch.aspx?hid=489147"
    },
    "property_features": {
      "adults_only": false,
      "family_friendly": false,
      "sustainability_certification": false,
      "primary_wellness_focus_property": true
    },
    "facilities": {
      "ayurveda_center": false,
      "spa": true,
      "yoga_pavilion": false,
      "meditation_hall": false,
      "fitness_center": false,
      "infinity_pool": true,
      "hydrotherapy_pool": false,
      "sauna": true,
      "steam_room": true,
      "jacuzzi": true,
      "salt_therapy_room": false,
      "wellness_library": false,
      "healing_garden": false,
      "herbal_garden": false,
      "walking_trails": true,
      "forest_bathing_area": true,
      "beachfront_wellness_space": true,
      "tea_plantation_walks": true
    },
    "activities_and_programs": {
      "outdoor_yoga_deck": false,
      "private_consultation_rooms": true,
      "sunrise_yoga": false,
      "sunset_yoga": false,
      "meditation_sessions": false,
      "breathwork": false,
      "mindfulness_workshops": false,
      "sound_healing": false,
      "chanting_sessions": false,
      "tai_chi": false,
      "qigong": false,
      "nature_walks": true,
      "forest_bathing": true,
      "bird_watching": true,
      "cooking_classes": true,
      "wellness_talks": false,
      "digital_detox_programs": false
    },
    "consultations_and_assessments": {
      "ayurvedic_doctor_consultation": false,
      "pulse_diagnosis": false,
      "lifestyle_assessment": false,
      "nutritional_consultation": false
    },
    "treatments_and_therapies": {
      "shirodhara": false,
      "shiro_abhyanga": false,
      "herbal_head_therapy": false,
      "abhyanga": false,
      "synchronised_abhyanga": false,
      "pinda_sweda": false,
      "udwardhana": false,
      "herbal_steam_bath": true,
      "sarvanga_dhara": false,
      "kati_basti": false,
      "greeva_basti": false,
      "janu_basti": false,
      "panchakarma": false,
      "vamana": false,
      "virechana": false,
      "basti": false,
      "nasya": false,
      "rakta_moksha": false
    },
    "segment_scores": {
      "holistic_healing_and_mindfulness_seekers": 3,
      "wellness_adventurers_and_nature_enthusiasts": 5,
      "luxury_rejuvenation_and_spa_retreaters": 5,
      "digital_detox_and_mental_wellness_travelers": 4,
      "cultural_and_ancestral_wellness_explorers": 5
    },
    "data_confidence": "High"
  },
  {
    "id": 544359,
    "name": "Underneath The Mango Tree - Beach and Spa Resort",
    "city": "Tangalle",
    "district": "Hambantota",
    "rating": 5,
    "images": [
      "http://pix4.agoda.net/hotelimages/544/544359/544359_15072119200032726234.jpg?s=312x&ca=4&ce=1",
      "http://pix5.agoda.net/hotelimages/544/544359/544359_14062313440019973551.jpg?s=312x&ca=13&ce=1",
      "http://pix1.agoda.net/hotelimages/544/544359/544359_15072119200032726230.jpg?s=312x&ca=4&ce=1",
      "http://pix5.agoda.net/hotelimages/544/544359/544359_15072119200032726231.jpg?s=312x&ca=4&ce=1",
      "http://pix2.agoda.net/hotelimages/544/544359/544359_15072119200032726232.jpg?s=312x&ca=4&ce=1"
    ],
    "primary_wellness_focus": "Coastal Wellness / Spa",
    "wellness_treatment_types": [
      "Stress Relief",
      "Relaxation",
      "Rejuvenation"
    ],
    "wellnessPackages": [
      "Spa Retreat",
      "Ayurveda & Holistic Healing",
      "Yoga & Meditation Center",
      "Rejuvenation & Burnout Recovery",
      "Nature Wellness and Eco Retreat",
      "Coastal Wellness & Spa"
    ],
    "hotel_Category": [
      "Luxury",
      "Boutique Luxury"
    ],
    "links": {
      "official_website": "https://www.crazyhollmann.com/en/sri-lanka-utmt/",
      "agoda_source_url": "https://www.agoda.com/partners/partnersearch.aspx?hid=544359"
    },
    "property_features": {
      "adults_only": false,
      "family_friendly": false,
      "sustainability_certification": false,
      "primary_wellness_focus_property": true
    },
    "facilities": {
      "ayurveda_center": false,
      "spa": true,
      "yoga_pavilion": false,
      "meditation_hall": false,
      "fitness_center": true,
      "infinity_pool": true,
      "hydrotherapy_pool": false,
      "sauna": true,
      "steam_room": true,
      "jacuzzi": false,
      "salt_therapy_room": false,
      "wellness_library": false,
      "healing_garden": false,
      "herbal_garden": false,
      "walking_trails": false,
      "forest_bathing_area": false,
      "beachfront_wellness_space": true,
      "tea_plantation_walks": true
    },
    "activities_and_programs": {
      "outdoor_yoga_deck": false,
      "private_consultation_rooms": true,
      "sunrise_yoga": false,
      "sunset_yoga": false,
      "meditation_sessions": false,
      "breathwork": false,
      "mindfulness_workshops": false,
      "sound_healing": false,
      "chanting_sessions": false,
      "tai_chi": false,
      "qigong": false,
      "nature_walks": false,
      "forest_bathing": false,
      "bird_watching": false,
      "cooking_classes": false,
      "wellness_talks": false,
      "digital_detox_programs": false
    },
    "consultations_and_assessments": {
      "ayurvedic_doctor_consultation": false,
      "pulse_diagnosis": false,
      "lifestyle_assessment": false,
      "nutritional_consultation": false
    },
    "treatments_and_therapies": {
      "shirodhara": false,
      "shiro_abhyanga": false,
      "herbal_head_therapy": false,
      "abhyanga": false,
      "synchronised_abhyanga": false,
      "pinda_sweda": false,
      "udwardhana": false,
      "herbal_steam_bath": true,
      "sarvanga_dhara": false,
      "kati_basti": false,
      "greeva_basti": false,
      "janu_basti": false,
      "panchakarma": false,
      "vamana": false,
      "virechana": false,
      "basti": false,
      "nasya": false,
      "rakta_moksha": false
    },
    "segment_scores": {
      "holistic_healing_and_mindfulness_seekers": 3,
      "wellness_adventurers_and_nature_enthusiasts": 4,
      "luxury_rejuvenation_and_spa_retreaters": 5,
      "digital_detox_and_mental_wellness_travelers": 4,
      "cultural_and_ancestral_wellness_explorers": 2
    },
    "data_confidence": "High"
  },
  {
    "id": 911449,
    "name": "Anantara Peace Haven Tangalle Resort",
    "city": "Tangalle",
    "district": "Hambantota",
    "rating": 5,
    "images": [
      "http://pix2.agoda.net/hotelimages/911/911449/911449_16031518070040782059.jpg?s=312x&ca=6&ce=1",
      "http://pix2.agoda.net/hotelimages/911/911449/911449_15042419030027088031.jpg?s=312x&ca=4&ce=1",
      "http://pix3.agoda.net/hotelimages/911/911449/911449_15081217270034142985.jpg?s=312x&ca=5&ce=1",
      "http://pix3.agoda.net/hotelimages/911/911449/911449_15081217270034142986.jpg?s=312x&ca=5&ce=1",
      "http://pix3.agoda.net/hotelimages/911/911449/911449_15081217270034142988.jpg?s=312x&ca=5&ce=1"
    ],
    "primary_wellness_focus": "Coastal Wellness / Spa",
    "wellness_treatment_types": [
      "Stress Relief",
      "Relaxation",
      "Rejuvenation"
    ],
    "wellnessPackages": [
      "Spa Retreat",
      "Detox & Clensing Program",
      "Ayurveda & Holistic Healing",
      "Yoga & Meditation Center",
      "Rejuvenation & Burnout Recovery",
      "Coastal Wellness & Spa"
    ],
    "hotel_Category": [
      "Luxury",
      "Boutique Luxury"
    ],
    "links": {
      "official_website": "https://www.anantara.com/en/peace-haven-tangalle",
      "agoda_source_url": "https://www.agoda.com/partners/partnersearch.aspx?hid=911449"
    },
    "property_features": {
      "adults_only": false,
      "family_friendly": false,
      "sustainability_certification": false,
      "primary_wellness_focus_property": true
    },
    "facilities": {
      "ayurveda_center": false,
      "spa": true,
      "yoga_pavilion": false,
      "meditation_hall": false,
      "fitness_center": true,
      "infinity_pool": true,
      "hydrotherapy_pool": false,
      "sauna": true,
      "steam_room": true,
      "jacuzzi": false,
      "salt_therapy_room": false,
      "wellness_library": false,
      "healing_garden": false,
      "herbal_garden": false,
      "walking_trails": false,
      "forest_bathing_area": false,
      "beachfront_wellness_space": true,
      "tea_plantation_walks": true
    },
    "activities_and_programs": {
      "outdoor_yoga_deck": false,
      "private_consultation_rooms": true,
      "sunrise_yoga": false,
      "sunset_yoga": false,
      "meditation_sessions": false,
      "breathwork": false,
      "mindfulness_workshops": false,
      "sound_healing": false,
      "chanting_sessions": false,
      "tai_chi": false,
      "qigong": false,
      "nature_walks": false,
      "forest_bathing": false,
      "bird_watching": false,
      "cooking_classes": true,
      "wellness_talks": false,
      "digital_detox_programs": false
    },
    "consultations_and_assessments": {
      "ayurvedic_doctor_consultation": false,
      "pulse_diagnosis": false,
      "lifestyle_assessment": false,
      "nutritional_consultation": true
    },
    "treatments_and_therapies": {
      "shirodhara": false,
      "shiro_abhyanga": false,
      "herbal_head_therapy": false,
      "abhyanga": false,
      "synchronised_abhyanga": false,
      "pinda_sweda": false,
      "udwardhana": false,
      "herbal_steam_bath": true,
      "sarvanga_dhara": false,
      "kati_basti": false,
      "greeva_basti": false,
      "janu_basti": false,
      "panchakarma": false,
      "vamana": false,
      "virechana": false,
      "basti": false,
      "nasya": false,
      "rakta_moksha": false
    },
    "segment_scores": {
      "holistic_healing_and_mindfulness_seekers": 3,
      "wellness_adventurers_and_nature_enthusiasts": 4,
      "luxury_rejuvenation_and_spa_retreaters": 5,
      "digital_detox_and_mental_wellness_travelers": 4,
      "cultural_and_ancestral_wellness_explorers": 2
    },
    "data_confidence": "High"
  },
  {
    "id": 1198359,
    "name": "Water Garden Sigiriya",
    "city": "Sigiriya",
    "district": "Matale",
    "rating": 5,
    "images": [
      "http://pix4.agoda.net/hotelimages/1198359/-1/66cefc2d3ef50f784b4ea2f95aaf3b5f.jpg?s=312x&ca=12&ce=1",
      "http://pix3.agoda.net/hotelimages/1198359/-1/a3c7c036fdf5e4bbbc28dc7d1223c872.jpg?s=312x&ca=12&ce=1",
      "http://pix3.agoda.net/hotelimages/1198359/-1/a3c7c036fdf5e4bbbc28dc7d1223c872.jpg?s=312x&ca=12&ce=1",
      "http://pix5.agoda.net/hotelimages/1198359/-1/97ef19e18159030c74f8c3d9166ffdf7.jpg?s=312x&ca=12&ce=1",
      "http://pix1.agoda.net/hotelimages/1198359/-1/43a4457325e4fc702e14d180f933d602.jpg?s=312x&ca=12&ce=1"
    ],
    "primary_wellness_focus": "Spa / Leisure Wellness",
    "wellness_treatment_types": [
      "Stress Relief",
      "Relaxation",
      "Rejuvenation"
    ],
    "wellnessPackages": [
      "Spa Retreat",
      "Detox & Clensing Program",
      "Ayurveda & Holistic Healing",
      "Yoga & Meditation Center",
      "Rejuvenation & Burnout Recovery",
      "Nature Wellness and Eco Retreat"
    ],
    "hotel_Category": [
      "Luxury",
      "Boutique Luxury"
    ],
    "links": {
      "official_website": "https://www.watergardensigiriya.com/spa-wellness/",
      "agoda_source_url": "https://www.agoda.com/partners/partnersearch.aspx?hid=1198359"
    },
    "property_features": {
      "adults_only": false,
      "family_friendly": false,
      "sustainability_certification": false,
      "primary_wellness_focus_property": true
    },
    "facilities": {
      "ayurveda_center": false,
      "spa": true,
      "yoga_pavilion": false,
      "meditation_hall": false,
      "fitness_center": true,
      "infinity_pool": true,
      "hydrotherapy_pool": false,
      "sauna": true,
      "steam_room": true,
      "jacuzzi": false,
      "salt_therapy_room": false,
      "wellness_library": false,
      "healing_garden": true,
      "herbal_garden": false,
      "walking_trails": true,
      "forest_bathing_area": true,
      "beachfront_wellness_space": false,
      "tea_plantation_walks": true
    },
    "activities_and_programs": {
      "outdoor_yoga_deck": false,
      "private_consultation_rooms": true,
      "sunrise_yoga": false,
      "sunset_yoga": false,
      "meditation_sessions": false,
      "breathwork": false,
      "mindfulness_workshops": false,
      "sound_healing": false,
      "chanting_sessions": false,
      "tai_chi": false,
      "qigong": false,
      "nature_walks": true,
      "forest_bathing": true,
      "bird_watching": true,
      "cooking_classes": true,
      "wellness_talks": false,
      "digital_detox_programs": false
    },
    "consultations_and_assessments": {
      "ayurvedic_doctor_consultation": false,
      "pulse_diagnosis": false,
      "lifestyle_assessment": false,
      "nutritional_consultation": false
    },
    "treatments_and_therapies": {
      "shirodhara": false,
      "shiro_abhyanga": false,
      "herbal_head_therapy": false,
      "abhyanga": false,
      "synchronised_abhyanga": false,
      "pinda_sweda": false,
      "udwardhana": false,
      "herbal_steam_bath": true,
      "sarvanga_dhara": false,
      "kati_basti": false,
      "greeva_basti": false,
      "janu_basti": false,
      "panchakarma": false,
      "vamana": false,
      "virechana": false,
      "basti": false,
      "nasya": false,
      "rakta_moksha": false
    },
    "segment_scores": {
      "holistic_healing_and_mindfulness_seekers": 3,
      "wellness_adventurers_and_nature_enthusiasts": 5,
      "luxury_rejuvenation_and_spa_retreaters": 5,
      "digital_detox_and_mental_wellness_travelers": 4,
      "cultural_and_ancestral_wellness_explorers": 5
    },
    "data_confidence": "High"
  },
  {
    "id": 2179007,
    "name": "Santani Wellness Kandy",
    "city": "Kandy",
    "district": "Kandy",
    "rating": 5,
    "images": [
      "http://pix1.agoda.net/hotelimages/2179007/-1/8543c5eb64320e372540fa2898c7cc04.jpg?s=312x&ce=0",
      "http://pix4.agoda.net/hotelimages/217/2179007/2179007_17042517010052624753.jpg?s=312x&ca=13&ce=1",
      "http://pix3.agoda.net/hotelimages/2179007/-1/d91a70799c5941c706ab1b02ac626ace.jpg?s=312x&ca=9&ce=1",
      "http://pix2.agoda.net/hotelimages/2179007/-1/9545ce2c55720034e4d7bac2d5a8524d.jpg?s=312x&ce=0",
      "http://pix4.agoda.net/hotelimages/2179007/-1/1c10d01d0d20db50910075ab95fcba5c.jpg?s=312x&ce=0"
    ],
    "primary_wellness_focus": "Wellness Retreat / Rejuvenation",
    "wellness_treatment_types": [
      "Relaxation",
      "Rejuvenation",
      "Detox",
      "Burnout Recovery",
      "Mental Wellness",
      "Yoga Retreat",
      "Meditation Retreat"
    ],
    "wellnessPackages": [
      "Spa Retreat",
      "Detox & Clensing Program",
      "Ayurveda & Holistic Healing",
      "Yoga & Meditation Center",
      "Rejuvenation & Burnout Recovery",
      "Medical Wellness",
      "Nature Wellness and Eco Retreat"
    ],
    "hotel_Category": [
      "Luxury",
      "Boutique Luxury"
    ],
    "links": {
      "official_website": "https://www.santani.com/santaniwellness-kandy/",
      "agoda_source_url": "https://www.agoda.com/partners/partnersearch.aspx?hid=2179007"
    },
    "property_features": {
      "adults_only": false,
      "family_friendly": false,
      "sustainability_certification": false,
      "primary_wellness_focus_property": true
    },
    "facilities": {
      "ayurveda_center": false,
      "spa": true,
      "yoga_pavilion": true,
      "meditation_hall": true,
      "fitness_center": false,
      "infinity_pool": true,
      "hydrotherapy_pool": false,
      "sauna": true,
      "steam_room": true,
      "jacuzzi": false,
      "salt_therapy_room": false,
      "wellness_library": false,
      "healing_garden": false,
      "herbal_garden": false,
      "walking_trails": false,
      "forest_bathing_area": false,
      "beachfront_wellness_space": true,
      "tea_plantation_walks": true
    },
    "activities_and_programs": {
      "outdoor_yoga_deck": true,
      "private_consultation_rooms": true,
      "sunrise_yoga": true,
      "sunset_yoga": true,
      "meditation_sessions": true,
      "breathwork": false,
      "mindfulness_workshops": true,
      "sound_healing": false,
      "chanting_sessions": false,
      "tai_chi": false,
      "qigong": false,
      "nature_walks": false,
      "forest_bathing": false,
      "bird_watching": false,
      "cooking_classes": true,
      "wellness_talks": true,
      "digital_detox_programs": true
    },
    "consultations_and_assessments": {
      "ayurvedic_doctor_consultation": false,
      "pulse_diagnosis": false,
      "lifestyle_assessment": true,
      "nutritional_consultation": false
    },
    "treatments_and_therapies": {
      "shirodhara": false,
      "shiro_abhyanga": false,
      "herbal_head_therapy": false,
      "abhyanga": false,
      "synchronised_abhyanga": false,
      "pinda_sweda": false,
      "udwardhana": false,
      "herbal_steam_bath": true,
      "sarvanga_dhara": false,
      "kati_basti": false,
      "greeva_basti": false,
      "janu_basti": false,
      "panchakarma": false,
      "vamana": false,
      "virechana": false,
      "basti": false,
      "nasya": false,
      "rakta_moksha": false
    },
    "segment_scores": {
      "holistic_healing_and_mindfulness_seekers": 5,
      "wellness_adventurers_and_nature_enthusiasts": 2,
      "luxury_rejuvenation_and_spa_retreaters": 5,
      "digital_detox_and_mental_wellness_travelers": 5,
      "cultural_and_ancestral_wellness_explorers": 5
    },
    "data_confidence": "High"
  },
  {
    "id": 2509865,
    "name": "Back of beyond - Wellness Retreat",
    "city": "Tangalle",
    "district": "",
    "rating": 3,
    "images": ['https://q-xx.bstatic.com/xdata/images/hotel/max1024x768/220459629.jpg?k=05b37cad4c210b4f88b1ffbdfa6f4d261e4480cc19402a093df2df85e5b60997&o=&s=600x'],
    "primary_wellness_focus": "Wellness Retreat / Rejuvenation",
    "wellness_treatment_types": [
      "Relaxation",
      "Rejuvenation",
      "Burnout Recovery",
      "Mental Wellness",
      "Yoga Retreat",
      "Meditation Retreat"
    ],
    "wellnessPackages": [
      "Spa Retreat",
      "Ayurveda & Holistic Healing",
      "Yoga & Meditation Center",
      "Rejuvenation & Burnout Recovery",
      "Nature Wellness and Eco Retreat",
      "Coastal Wellness & Spa"
    ],
    "hotel_Category": [
      "Boutique",
      "Eco Wellness"
    ],
    "links": {
      "official_website": "https://www.lankawellness.com/",
      "agoda_source_url": "https://www.agoda.com/partners/partnersearch.aspx?hid=2509865"
    },
    "property_features": {
      "adults_only": false,
      "family_friendly": false,
      "sustainability_certification": false,
      "primary_wellness_focus_property": true
    },
    "facilities": {
      "ayurveda_center": false,
      "spa": true,
      "yoga_pavilion": true,
      "meditation_hall": true,
      "fitness_center": false,
      "infinity_pool": false,
      "hydrotherapy_pool": false,
      "sauna": false,
      "steam_room": false,
      "jacuzzi": false,
      "salt_therapy_room": false,
      "wellness_library": false,
      "healing_garden": false,
      "herbal_garden": false,
      "walking_trails": false,
      "forest_bathing_area": false,
      "beachfront_wellness_space": true,
      "tea_plantation_walks": false
    },
    "activities_and_programs": {
      "outdoor_yoga_deck": true,
      "private_consultation_rooms": true,
      "sunrise_yoga": true,
      "sunset_yoga": true,
      "meditation_sessions": true,
      "breathwork": false,
      "mindfulness_workshops": true,
      "sound_healing": false,
      "chanting_sessions": false,
      "tai_chi": false,
      "qigong": false,
      "nature_walks": false,
      "forest_bathing": false,
      "bird_watching": false,
      "cooking_classes": false,
      "wellness_talks": true,
      "digital_detox_programs": true
    },
    "consultations_and_assessments": {
      "ayurvedic_doctor_consultation": false,
      "pulse_diagnosis": false,
      "lifestyle_assessment": true,
      "nutritional_consultation": false
    },
    "treatments_and_therapies": {
      "shirodhara": false,
      "shiro_abhyanga": false,
      "herbal_head_therapy": false,
      "abhyanga": false,
      "synchronised_abhyanga": false,
      "pinda_sweda": false,
      "udwardhana": false,
      "herbal_steam_bath": false,
      "sarvanga_dhara": false,
      "kati_basti": false,
      "greeva_basti": false,
      "janu_basti": false,
      "panchakarma": false,
      "vamana": false,
      "virechana": false,
      "basti": false,
      "nasya": false,
      "rakta_moksha": false
    },
    "segment_scores": {
      "holistic_healing_and_mindfulness_seekers": 5,
      "wellness_adventurers_and_nature_enthusiasts": 2,
      "luxury_rejuvenation_and_spa_retreaters": 2,
      "digital_detox_and_mental_wellness_travelers": 5,
      "cultural_and_ancestral_wellness_explorers": 2
    },
    "data_confidence": "High"
  },
  {
    "id": 4662629,
    "name": "Flameback Eco Lodge",
    "city": "Yala",
    "district": "Moneragala",
    "rating": 3.5,
    "images": [
      "http://pix2.agoda.net/hotelimages/4662629/-1/4e4f03b34490ead8766f2d06b94532a4.jpg?s=312x&ca=0&ce=1",
      "http://pix3.agoda.net/hotelimages/4662629/-1/4b5c093a448b85107aa1e8a01428c981.jpg?s=312x&ca=13&ce=1",
      "http://pix4.agoda.net/hotelimages/4662629/-1/4494b2dd3e014b6e47cacecb6e2dcfe0.jpg?s=312x&ca=7&ce=1",
      "http://pix2.agoda.net/hotelimages/4662629/-1/b5b3fbc133b002548a4bc2fcc6366d60.jpg?s=312x&ca=7&ce=1",
      "http://pix4.agoda.net/hotelimages/4662629/-1/5e373e7675f638924ebe967984f1c79b.jpg?s=312x&ca=7&ce=1"
    ],
    "primary_wellness_focus": "Nature Wellness / Eco Retreat",
    "wellness_treatment_types": [
      "Stress Relief",
      "Relaxation"
    ],
    "wellnessPackages": [
      "Spa Retreat",
      "Yoga & Meditation Center",
      "Rejuvenation & Burnout Recovery",
      "Nature Wellness and Eco Retreat"
    ],
    "hotel_Category": [
      "Boutique",
      "Eco Wellness"
    ],
    "links": {
      "official_website": "https://www.flamebackecolodge.com/yoga-retreat/",
      "agoda_source_url": "https://www.agoda.com/partners/partnersearch.aspx?hid=4662629"
    },
    "property_features": {
      "adults_only": false,
      "family_friendly": false,
      "sustainability_certification": false,
      "primary_wellness_focus_property": true
    },
    "facilities": {
      "ayurveda_center": false,
      "spa": false,
      "yoga_pavilion": false,
      "meditation_hall": false,
      "fitness_center": true,
      "infinity_pool": true,
      "hydrotherapy_pool": false,
      "sauna": false,
      "steam_room": false,
      "jacuzzi": false,
      "salt_therapy_room": false,
      "wellness_library": false,
      "healing_garden": false,
      "herbal_garden": false,
      "walking_trails": true,
      "forest_bathing_area": true,
      "beachfront_wellness_space": true,
      "tea_plantation_walks": true
    },
    "activities_and_programs": {
      "outdoor_yoga_deck": false,
      "private_consultation_rooms": false,
      "sunrise_yoga": false,
      "sunset_yoga": false,
      "meditation_sessions": false,
      "breathwork": false,
      "mindfulness_workshops": false,
      "sound_healing": false,
      "chanting_sessions": false,
      "tai_chi": false,
      "qigong": false,
      "nature_walks": true,
      "forest_bathing": true,
      "bird_watching": true,
      "cooking_classes": true,
      "wellness_talks": false,
      "digital_detox_programs": false
    },
    "consultations_and_assessments": {
      "ayurvedic_doctor_consultation": false,
      "pulse_diagnosis": false,
      "lifestyle_assessment": false,
      "nutritional_consultation": false
    },
    "treatments_and_therapies": {
      "shirodhara": false,
      "shiro_abhyanga": false,
      "herbal_head_therapy": false,
      "abhyanga": false,
      "synchronised_abhyanga": false,
      "pinda_sweda": false,
      "udwardhana": false,
      "herbal_steam_bath": false,
      "sarvanga_dhara": false,
      "kati_basti": false,
      "greeva_basti": false,
      "janu_basti": false,
      "panchakarma": false,
      "vamana": false,
      "virechana": false,
      "basti": false,
      "nasya": false,
      "rakta_moksha": false
    },
    "segment_scores": {
      "holistic_healing_and_mindfulness_seekers": 2,
      "wellness_adventurers_and_nature_enthusiasts": 5,
      "luxury_rejuvenation_and_spa_retreaters": 2,
      "digital_detox_and_mental_wellness_travelers": 5,
      "cultural_and_ancestral_wellness_explorers": 2
    },
    "data_confidence": "High"
  },
  {
    "id": 10730866,
    "name": "Bamboo Bungalow in Ayurvedic Retreat",
    "city": "Tangalle",
    "district": "Hambantota",
    "rating": 4,
    "images": ['https://pix8.agoda.net/hotelImages/10730866/0/25423c329945165ffb5178908a6d0951.jpg?va=1&ca=9&ce=1&s=1024x'],
    "primary_wellness_focus": "Ayurveda / Holistic Healing",
    "wellness_treatment_types": [
      "Stress Relief",
      "Relaxation",
      "Rejuvenation",
      "Weight Loss",
      "Detox",
      "Panchakarma Program",
      "Burnout Recovery",
      "Mental Wellness",
      "Yoga Retreat",
      "Meditation Retreat"
    ],
    "wellnessPackages": [
      "Spa Retreat",
      "Detox & Clensing Program",
      "Ayurveda & Holistic Healing",
      "Yoga & Meditation Center",
      "Rejuvenation & Burnout Recovery"
    ],
    "hotel_Category": [
      "Boutique",
      "Eco Wellness"
    ],
    "links": {
      "official_website": "",
      "agoda_source_url": "https://www.agoda.com/partners/partnersearch.aspx?hid=10730866"
    },
    "property_features": {
      "adults_only": false,
      "family_friendly": false,
      "sustainability_certification": false,
      "primary_wellness_focus_property": true
    },
    "facilities": {
      "ayurveda_center": true,
      "spa": false,
      "yoga_pavilion": true,
      "meditation_hall": true,
      "fitness_center": true,
      "infinity_pool": false,
      "hydrotherapy_pool": false,
      "sauna": false,
      "steam_room": true,
      "jacuzzi": false,
      "salt_therapy_room": false,
      "wellness_library": false,
      "healing_garden": false,
      "herbal_garden": true,
      "walking_trails": false,
      "forest_bathing_area": false,
      "beachfront_wellness_space": true,
      "tea_plantation_walks": true
    },
    "activities_and_programs": {
      "outdoor_yoga_deck": true,
      "private_consultation_rooms": true,
      "sunrise_yoga": true,
      "sunset_yoga": true,
      "meditation_sessions": true,
      "breathwork": false,
      "mindfulness_workshops": true,
      "sound_healing": false,
      "chanting_sessions": false,
      "tai_chi": false,
      "qigong": false,
      "nature_walks": false,
      "forest_bathing": false,
      "bird_watching": false,
      "cooking_classes": false,
      "wellness_talks": false,
      "digital_detox_programs": true
    },
    "consultations_and_assessments": {
      "ayurvedic_doctor_consultation": true,
      "pulse_diagnosis": true,
      "lifestyle_assessment": true,
      "nutritional_consultation": true
    },
    "treatments_and_therapies": {
      "shirodhara": true,
      "shiro_abhyanga": true,
      "herbal_head_therapy": true,
      "abhyanga": true,
      "synchronised_abhyanga": false,
      "pinda_sweda": false,
      "udwardhana": false,
      "herbal_steam_bath": true,
      "sarvanga_dhara": false,
      "kati_basti": false,
      "greeva_basti": false,
      "janu_basti": false,
      "panchakarma": true,
      "vamana": false,
      "virechana": true,
      "basti": true,
      "nasya": true,
      "rakta_moksha": false
    },
    "segment_scores": {
      "holistic_healing_and_mindfulness_seekers": 5,
      "wellness_adventurers_and_nature_enthusiasts": 2,
      "luxury_rejuvenation_and_spa_retreaters": 2,
      "digital_detox_and_mental_wellness_travelers": 5,
      "cultural_and_ancestral_wellness_explorers": 2
    },
    "data_confidence": "Medium"
  },
  {
    "id": 12469972,
    "name": "Ayurveda Villa 386 - Veda Villa - All Inclusive",
    "city": "Hikkaduwa",
    "district": "Galle",
    "rating": 4.5,
    "images": ['https://q-xx.bstatic.com/xdata/images/hotel/max1024x768/498457213.jpg?k=1422192e92702c05d600e033f0e41e38917dd7b9dfa625935f09c9cd2275cc5b&o=&s=1024x'],
    "primary_wellness_focus": "Ayurveda / Holistic Healing",
    "wellness_treatment_types": [
      "Stress Relief",
      "Relaxation",
      "Rejuvenation",
      "Weight Loss",
      "Detox",
      "Panchakarma Program",
      "Mental Wellness",
      "Yoga Retreat"
    ],
    "wellnessPackages": [
      "Spa Retreat",
      "Detox & Clensing Program",
      "Ayurveda & Holistic Healing",
      "Yoga & Meditation Center",
      "Rejuvenation & Burnout Recovery",
      "Medical Wellness"
    ],
    "hotel_Category": [
      "Boutique",
      "Eco Wellness"
    ],
    "links": {
      "official_website": "https://villa386.com/",
      "agoda_source_url": "https://www.agoda.com/partners/partnersearch.aspx?hid=12469972"
    },
    "property_features": {
      "adults_only": false,
      "family_friendly": false,
      "sustainability_certification": false,
      "primary_wellness_focus_property": true
    },
    "facilities": {
      "ayurveda_center": true,
      "spa": true,
      "yoga_pavilion": true,
      "meditation_hall": false,
      "fitness_center": false,
      "infinity_pool": true,
      "hydrotherapy_pool": false,
      "sauna": false,
      "steam_room": true,
      "jacuzzi": false,
      "salt_therapy_room": false,
      "wellness_library": false,
      "healing_garden": false,
      "herbal_garden": true,
      "walking_trails": true,
      "forest_bathing_area": true,
      "beachfront_wellness_space": true,
      "tea_plantation_walks": true
    },
    "activities_and_programs": {
      "outdoor_yoga_deck": true,
      "private_consultation_rooms": true,
      "sunrise_yoga": true,
      "sunset_yoga": true,
      "meditation_sessions": false,
      "breathwork": false,
      "mindfulness_workshops": false,
      "sound_healing": false,
      "chanting_sessions": false,
      "tai_chi": false,
      "qigong": false,
      "nature_walks": true,
      "forest_bathing": true,
      "bird_watching": true,
      "cooking_classes": true,
      "wellness_talks": true,
      "digital_detox_programs": false
    },
    "consultations_and_assessments": {
      "ayurvedic_doctor_consultation": true,
      "pulse_diagnosis": true,
      "lifestyle_assessment": true,
      "nutritional_consultation": true
    },
    "treatments_and_therapies": {
      "shirodhara": true,
      "shiro_abhyanga": true,
      "herbal_head_therapy": true,
      "abhyanga": true,
      "synchronised_abhyanga": false,
      "pinda_sweda": false,
      "udwardhana": false,
      "herbal_steam_bath": true,
      "sarvanga_dhara": false,
      "kati_basti": false,
      "greeva_basti": false,
      "janu_basti": false,
      "panchakarma": true,
      "vamana": false,
      "virechana": true,
      "basti": true,
      "nasya": true,
      "rakta_moksha": false
    },
    "segment_scores": {
      "holistic_healing_and_mindfulness_seekers": 5,
      "wellness_adventurers_and_nature_enthusiasts": 5,
      "luxury_rejuvenation_and_spa_retreaters": 5,
      "digital_detox_and_mental_wellness_travelers": 5,
      "cultural_and_ancestral_wellness_explorers": 4
    },
    "data_confidence": "High"
  },
  {
    "id": 15424506,
    "name": "Ariyana Wellness Retreat Yala",
    "city": "Yala",
    "district": "",
    "rating": 3,
    "images": [],
    "primary_wellness_focus": "Wellness Retreat / Rejuvenation",
    "wellness_treatment_types": [
      "Relaxation",
      "Rejuvenation",
      "Burnout Recovery",
      "Mental Wellness",
      "Yoga Retreat",
      "Meditation Retreat"
    ],
    "wellnessPackages": [
      "Spa Retreat",
      "Detox & Clensing Program",
      "Ayurveda & Holistic Healing",
      "Nature Wellness and Eco Retreat",
      "Coastal Wellness & Spa"
    ],
    "hotel_Category": [
      "Boutique",
      "Eco Wellness"
    ],
    "links": {
      "official_website": "",
      "agoda_source_url": "https://www.agoda.com/partners/partnersearch.aspx?hid=15424506"
    },
    "property_features": {
      "adults_only": false,
      "family_friendly": false,
      "sustainability_certification": false,
      "primary_wellness_focus_property": true
    },
    "facilities": {
      "ayurveda_center": false,
      "spa": true,
      "yoga_pavilion": true,
      "meditation_hall": true,
      "fitness_center": false,
      "infinity_pool": false,
      "hydrotherapy_pool": false,
      "sauna": false,
      "steam_room": false,
      "jacuzzi": false,
      "salt_therapy_room": false,
      "wellness_library": false,
      "healing_garden": false,
      "herbal_garden": false,
      "walking_trails": true,
      "forest_bathing_area": true,
      "beachfront_wellness_space": false,
      "tea_plantation_walks": false
    },
    "activities_and_programs": {
      "outdoor_yoga_deck": true,
      "private_consultation_rooms": true,
      "sunrise_yoga": true,
      "sunset_yoga": true,
      "meditation_sessions": true,
      "breathwork": false,
      "mindfulness_workshops": true,
      "sound_healing": false,
      "chanting_sessions": false,
      "tai_chi": false,
      "qigong": false,
      "nature_walks": true,
      "forest_bathing": true,
      "bird_watching": true,
      "cooking_classes": false,
      "wellness_talks": true,
      "digital_detox_programs": true
    },
    "consultations_and_assessments": {
      "ayurvedic_doctor_consultation": false,
      "pulse_diagnosis": false,
      "lifestyle_assessment": true,
      "nutritional_consultation": false
    },
    "treatments_and_therapies": {
      "shirodhara": false,
      "shiro_abhyanga": false,
      "herbal_head_therapy": false,
      "abhyanga": false,
      "synchronised_abhyanga": false,
      "pinda_sweda": false,
      "udwardhana": false,
      "herbal_steam_bath": false,
      "sarvanga_dhara": false,
      "kati_basti": false,
      "greeva_basti": false,
      "janu_basti": false,
      "panchakarma": false,
      "vamana": false,
      "virechana": false,
      "basti": false,
      "nasya": false,
      "rakta_moksha": false
    },
    "segment_scores": {
      "holistic_healing_and_mindfulness_seekers": 5,
      "wellness_adventurers_and_nature_enthusiasts": 5,
      "luxury_rejuvenation_and_spa_retreaters": 2,
      "digital_detox_and_mental_wellness_travelers": 5,
      "cultural_and_ancestral_wellness_explorers": 2
    },
    "data_confidence": "Low"
  },
  {
    "id": 23704235,
    "name": "OLU AYURVEDA BEACH RESORT",
    "city": "Mirissa",
    "district": "Matara",
    "rating": 4,
    "images": ['https://pix8.agoda.net/hotelImages/237/23704235/23704235_21041701190096698557.jpg?va=1&ca=18&ce=1&s=1024x'],
    "primary_wellness_focus": "Ayurveda / Holistic Healing",
    "wellness_treatment_types": [
      "Stress Relief",
      "Relaxation",
      "Rejuvenation",
      "Weight Loss",
      "Detox",
      "Panchakarma Program",
      "Mental Wellness",
      "Yoga Retreat"
    ],
    "wellnessPackages": [
      "Spa Retreat",
      "Detox & Clensing Program",
      "Ayurveda & Holistic Healing",
      "Yoga & Meditation Center",
      "Rejuvenation & Burnout Recovery",
      "Coastal Wellness & Spa"
    ],
    "hotel_Category": [
      "Boutique",
      "Eco Wellness"
    ],
    "links": {
      "official_website": "https://www.oluayurvedabeach.lk/",
      "agoda_source_url": "https://www.agoda.com/partners/partnersearch.aspx?hid=23704235"
    },
    "property_features": {
      "adults_only": false,
      "family_friendly": false,
      "sustainability_certification": false,
      "primary_wellness_focus_property": true
    },
    "facilities": {
      "ayurveda_center": true,
      "spa": false,
      "yoga_pavilion": true,
      "meditation_hall": false,
      "fitness_center": false,
      "infinity_pool": true,
      "hydrotherapy_pool": false,
      "sauna": false,
      "steam_room": true,
      "jacuzzi": false,
      "salt_therapy_room": false,
      "wellness_library": false,
      "healing_garden": false,
      "herbal_garden": true,
      "walking_trails": false,
      "forest_bathing_area": false,
      "beachfront_wellness_space": true,
      "tea_plantation_walks": false
    },
    "activities_and_programs": {
      "outdoor_yoga_deck": true,
      "private_consultation_rooms": true,
      "sunrise_yoga": true,
      "sunset_yoga": true,
      "meditation_sessions": false,
      "breathwork": false,
      "mindfulness_workshops": false,
      "sound_healing": false,
      "chanting_sessions": false,
      "tai_chi": false,
      "qigong": false,
      "nature_walks": false,
      "forest_bathing": false,
      "bird_watching": false,
      "cooking_classes": false,
      "wellness_talks": true,
      "digital_detox_programs": false
    },
    "consultations_and_assessments": {
      "ayurvedic_doctor_consultation": true,
      "pulse_diagnosis": true,
      "lifestyle_assessment": true,
      "nutritional_consultation": true
    },
    "treatments_and_therapies": {
      "shirodhara": true,
      "shiro_abhyanga": true,
      "herbal_head_therapy": true,
      "abhyanga": true,
      "synchronised_abhyanga": false,
      "pinda_sweda": false,
      "udwardhana": false,
      "herbal_steam_bath": true,
      "sarvanga_dhara": false,
      "kati_basti": false,
      "greeva_basti": false,
      "janu_basti": false,
      "panchakarma": true,
      "vamana": false,
      "virechana": true,
      "basti": true,
      "nasya": true,
      "rakta_moksha": false
    },
    "segment_scores": {
      "holistic_healing_and_mindfulness_seekers": 5,
      "wellness_adventurers_and_nature_enthusiasts": 4,
      "luxury_rejuvenation_and_spa_retreaters": 4,
      "digital_detox_and_mental_wellness_travelers": 5,
      "cultural_and_ancestral_wellness_explorers": 4
    },
    "data_confidence": "High"
  },
  {
    "id": 28738965,
    "name": "Wild Glamping Gal Oya - Thema Collection",
    "city": "Gal Oya",
    "district": "Moneragala",
    "rating": 0,
    "images": [
      "http://pix5.agoda.net/hotelimages/28738965/-1/4b4804ee06e91587ac296fad333f7a4a.jpg?s=312x&ce=0",
      "http://pix3.agoda.net/hotelimages/287/28738965/28738965_211115152200108182821.png?s=312x",
      "http://pix3.agoda.net/hotelimages/287/28738965/28738965_211115152200108182822.png?s=312x",
      "http://pix3.agoda.net/hotelimages/287/28738965/28738965_211115152200108182823.png?s=312x",
      "http://pix3.agoda.net/hotelimages/287/28738965/28738965_211125111900108824800.jpg?s=312x"
    ],
    "primary_wellness_focus": "Nature Wellness / Eco Retreat",
    "wellness_treatment_types": [
      "Relaxation"
    ],
    "wellnessPackages": [
      "Ayurveda & Holistic Healing",
      "Nature Wellness and Eco Retreat"
    ],
    "hotel_Category": [
      "Boutique",
      "Eco Wellness"
    ],
    "links": {
      "official_website": "",
      "agoda_source_url": "https://www.agoda.com/partners/partnersearch.aspx?hid=28738965"
    },
    "property_features": {
      "adults_only": false,
      "family_friendly": false,
      "sustainability_certification": false,
      "primary_wellness_focus_property": true
    },
    "facilities": {
      "ayurveda_center": false,
      "spa": false,
      "yoga_pavilion": false,
      "meditation_hall": false,
      "fitness_center": false,
      "infinity_pool": true,
      "hydrotherapy_pool": false,
      "sauna": false,
      "steam_room": false,
      "jacuzzi": false,
      "salt_therapy_room": false,
      "wellness_library": false,
      "healing_garden": false,
      "herbal_garden": false,
      "walking_trails": true,
      "forest_bathing_area": true,
      "beachfront_wellness_space": false,
      "tea_plantation_walks": false
    },
    "activities_and_programs": {
      "outdoor_yoga_deck": false,
      "private_consultation_rooms": false,
      "sunrise_yoga": false,
      "sunset_yoga": false,
      "meditation_sessions": false,
      "breathwork": false,
      "mindfulness_workshops": false,
      "sound_healing": false,
      "chanting_sessions": false,
      "tai_chi": false,
      "qigong": false,
      "nature_walks": true,
      "forest_bathing": true,
      "bird_watching": true,
      "cooking_classes": false,
      "wellness_talks": false,
      "digital_detox_programs": false
    },
    "consultations_and_assessments": {
      "ayurvedic_doctor_consultation": false,
      "pulse_diagnosis": false,
      "lifestyle_assessment": false,
      "nutritional_consultation": false
    },
    "treatments_and_therapies": {
      "shirodhara": false,
      "shiro_abhyanga": false,
      "herbal_head_therapy": false,
      "abhyanga": false,
      "synchronised_abhyanga": false,
      "pinda_sweda": false,
      "udwardhana": false,
      "herbal_steam_bath": false,
      "sarvanga_dhara": false,
      "kati_basti": false,
      "greeva_basti": false,
      "janu_basti": false,
      "panchakarma": false,
      "vamana": false,
      "virechana": false,
      "basti": false,
      "nasya": false,
      "rakta_moksha": false
    },
    "segment_scores": {
      "holistic_healing_and_mindfulness_seekers": 2,
      "wellness_adventurers_and_nature_enthusiasts": 5,
      "luxury_rejuvenation_and_spa_retreaters": 2,
      "digital_detox_and_mental_wellness_travelers": 5,
      "cultural_and_ancestral_wellness_explorers": 2
    },
    "data_confidence": "Medium"
  },
  {
    "id": 30798620,
    "name": "Ayur Ayur Ayurveda Retreat",
    "city": "Negombo",
    "district": "Gampaha",
    "rating": 4,
    "images": ['https://pix8.agoda.net/hotelImages/30798620/0/0eaf966a1b161d64bd7496d8ab4d8f31.jpg?va=1&ca=27&ce=0&s=600x'],
    "primary_wellness_focus": "Ayurveda / Holistic Healing",
    "wellness_treatment_types": [
      "Stress Relief",
      "Relaxation",
      "Rejuvenation",
      "Weight Loss",
      "Detox",
      "Panchakarma Program",
      "Burnout Recovery",
      "Mental Wellness",
      "Yoga Retreat",
      "Meditation Retreat"
    ],
    "wellnessPackages": [
      "Spa Retreat",
      "Detox & Clensing Program",
      "Ayurveda & Holistic Healing",
      "Yoga & Meditation Center",
      "Rejuvenation & Burnout Recovery",
      "Nature Wellness and Eco Retreat"
    ],
    "hotel_Category": [
      "Boutique",
      "Eco Wellness"
    ],
    "links": {
      "official_website": "",
      "agoda_source_url": "https://www.agoda.com/partners/partnersearch.aspx?hid=30798620"
    },
    "property_features": {
      "adults_only": false,
      "family_friendly": false,
      "sustainability_certification": false,
      "primary_wellness_focus_property": true
    },
    "facilities": {
      "ayurveda_center": true,
      "spa": false,
      "yoga_pavilion": true,
      "meditation_hall": true,
      "fitness_center": false,
      "infinity_pool": false,
      "hydrotherapy_pool": false,
      "sauna": false,
      "steam_room": true,
      "jacuzzi": false,
      "salt_therapy_room": false,
      "wellness_library": false,
      "healing_garden": false,
      "herbal_garden": true,
      "walking_trails": false,
      "forest_bathing_area": false,
      "beachfront_wellness_space": true,
      "tea_plantation_walks": false
    },
    "activities_and_programs": {
      "outdoor_yoga_deck": true,
      "private_consultation_rooms": true,
      "sunrise_yoga": true,
      "sunset_yoga": true,
      "meditation_sessions": true,
      "breathwork": false,
      "mindfulness_workshops": true,
      "sound_healing": false,
      "chanting_sessions": false,
      "tai_chi": false,
      "qigong": false,
      "nature_walks": false,
      "forest_bathing": false,
      "bird_watching": false,
      "cooking_classes": false,
      "wellness_talks": true,
      "digital_detox_programs": true
    },
    "consultations_and_assessments": {
      "ayurvedic_doctor_consultation": true,
      "pulse_diagnosis": true,
      "lifestyle_assessment": true,
      "nutritional_consultation": true
    },
    "treatments_and_therapies": {
      "shirodhara": true,
      "shiro_abhyanga": true,
      "herbal_head_therapy": true,
      "abhyanga": true,
      "synchronised_abhyanga": false,
      "pinda_sweda": false,
      "udwardhana": false,
      "herbal_steam_bath": true,
      "sarvanga_dhara": false,
      "kati_basti": false,
      "greeva_basti": false,
      "janu_basti": false,
      "panchakarma": true,
      "vamana": false,
      "virechana": true,
      "basti": true,
      "nasya": true,
      "rakta_moksha": false
    },
    "segment_scores": {
      "holistic_healing_and_mindfulness_seekers": 5,
      "wellness_adventurers_and_nature_enthusiasts": 4,
      "luxury_rejuvenation_and_spa_retreaters": 2,
      "digital_detox_and_mental_wellness_travelers": 5,
      "cultural_and_ancestral_wellness_explorers": 4
    },
    "data_confidence": "Medium"
  },
  {
    "id": 36808379,
    "name": "Kayaam Wellness",
    "city": "Tangalle",
    "district": "",
    "rating": 5,
    "images": ['https://q-xx.bstatic.com/xdata/images/hotel/max1024x768/855699092.jpg?k=03c1f1435241596b285f2901b106ff8135d7ef00dbe967e5cdd26da6a7183551&o=&s=600x'],
    "primary_wellness_focus": "Wellness Retreat / Rejuvenation",
    "wellness_treatment_types": [
      "Relaxation",
      "Rejuvenation",
      "Burnout Recovery",
      "Mental Wellness",
      "Yoga Retreat",
      "Meditation Retreat"
    ],
    "wellnessPackages": [
      "Spa Retreat",
      "Detox & Clensing Program",
      "Ayurveda & Holistic Healing",
      "Yoga & Meditation Center",
      "Rejuvenation & Burnout Recovery",
      "Nature Wellness and Eco Retreat",
      "Coastal Wellness & Spa"
    ],
    "hotel_Category": [
      "Luxury",
      "Boutique Luxury"
    ],
    "links": {
      "official_website": "https://www.resplendentceylon.com/resort/kayaam-wellness/",
      "agoda_source_url": "https://www.agoda.com/partners/partnersearch.aspx?hid=36808379"
    },
    "property_features": {
      "adults_only": false,
      "family_friendly": false,
      "sustainability_certification": false,
      "primary_wellness_focus_property": true
    },
    "facilities": {
      "ayurveda_center": false,
      "spa": true,
      "yoga_pavilion": true,
      "meditation_hall": true,
      "fitness_center": false,
      "infinity_pool": false,
      "hydrotherapy_pool": false,
      "sauna": false,
      "steam_room": false,
      "jacuzzi": false,
      "salt_therapy_room": false,
      "wellness_library": false,
      "healing_garden": false,
      "herbal_garden": false,
      "walking_trails": false,
      "forest_bathing_area": false,
      "beachfront_wellness_space": true,
      "tea_plantation_walks": false
    },
    "activities_and_programs": {
      "outdoor_yoga_deck": true,
      "private_consultation_rooms": true,
      "sunrise_yoga": true,
      "sunset_yoga": true,
      "meditation_sessions": true,
      "breathwork": false,
      "mindfulness_workshops": true,
      "sound_healing": false,
      "chanting_sessions": false,
      "tai_chi": false,
      "qigong": false,
      "nature_walks": false,
      "forest_bathing": false,
      "bird_watching": false,
      "cooking_classes": false,
      "wellness_talks": true,
      "digital_detox_programs": false
    },
    "consultations_and_assessments": {
      "ayurvedic_doctor_consultation": false,
      "pulse_diagnosis": false,
      "lifestyle_assessment": true,
      "nutritional_consultation": false
    },
    "treatments_and_therapies": {
      "shirodhara": false,
      "shiro_abhyanga": false,
      "herbal_head_therapy": false,
      "abhyanga": false,
      "synchronised_abhyanga": false,
      "pinda_sweda": false,
      "udwardhana": false,
      "herbal_steam_bath": false,
      "sarvanga_dhara": false,
      "kati_basti": false,
      "greeva_basti": false,
      "janu_basti": false,
      "panchakarma": false,
      "vamana": false,
      "virechana": false,
      "basti": false,
      "nasya": false,
      "rakta_moksha": false
    },
    "segment_scores": {
      "holistic_healing_and_mindfulness_seekers": 5,
      "wellness_adventurers_and_nature_enthusiasts": 2,
      "luxury_rejuvenation_and_spa_retreaters": 2,
      "digital_detox_and_mental_wellness_travelers": 5,
      "cultural_and_ancestral_wellness_explorers": 2
    },
    "data_confidence": "High"
  },
  {
    "id": 38271653,
    "name": "Anasa Wellness Resort",
    "city": "Sigiriya",
    "district": "Badulla",
    "rating": 5,
    "images": [
      "http://pix2.agoda.net/hotelimages/38271653/0/06f2ed24d528cac591b0d620929ea09c.jpg?s=312x&ce=0",
      "http://pix5.agoda.net/hotelimages/38271653/0/3e4b6bba2ba0c8e4fa0343c4a7d00721.jpg?s=312x&ce=0",
      "http://pix1.agoda.net/hotelimages/38271653/0/d776c3a1324ef8a9d4b6465f494b7edc.jpg?s=312x&ce=0",
      "http://pix2.agoda.net/hotelimages/38271653/0/4ca132e35c075cc07e339c54a74e442c.jpg?s=312x&ce=0"
    ],
    "primary_wellness_focus": "Wellness Retreat / Rejuvenation",
    "wellness_treatment_types": [
      "Relaxation",
      "Rejuvenation",
      "Burnout Recovery",
      "Mental Wellness",
      "Yoga Retreat",
      "Meditation Retreat"
    ],
    "wellnessPackages": [
      "Spa Retreat",
      "Detox & Clensing Program",
      "Yoga & Meditation Center",
      "Rejuvenation & Burnout Recovery",
      "Medical Wellness",
      "Nature Wellness and Eco Retreat"
    ],
    "hotel_Category": [
      "Luxury",
      "Boutique Luxury"
    ],
    "links": {
      "official_website": "https://www.anasawellnessresort.com/",
      "agoda_source_url": "https://www.agoda.com/partners/partnersearch.aspx?hid=38271653"
    },
    "property_features": {
      "adults_only": false,
      "family_friendly": false,
      "sustainability_certification": false,
      "primary_wellness_focus_property": true
    },
    "facilities": {
      "ayurveda_center": false,
      "spa": true,
      "yoga_pavilion": true,
      "meditation_hall": true,
      "fitness_center": false,
      "infinity_pool": true,
      "hydrotherapy_pool": false,
      "sauna": false,
      "steam_room": false,
      "jacuzzi": false,
      "salt_therapy_room": false,
      "wellness_library": false,
      "healing_garden": false,
      "herbal_garden": false,
      "walking_trails": true,
      "forest_bathing_area": true,
      "beachfront_wellness_space": false,
      "tea_plantation_walks": false
    },
    "activities_and_programs": {
      "outdoor_yoga_deck": true,
      "private_consultation_rooms": true,
      "sunrise_yoga": true,
      "sunset_yoga": true,
      "meditation_sessions": true,
      "breathwork": false,
      "mindfulness_workshops": true,
      "sound_healing": false,
      "chanting_sessions": false,
      "tai_chi": false,
      "qigong": false,
      "nature_walks": true,
      "forest_bathing": true,
      "bird_watching": true,
      "cooking_classes": false,
      "wellness_talks": true,
      "digital_detox_programs": false
    },
    "consultations_and_assessments": {
      "ayurvedic_doctor_consultation": false,
      "pulse_diagnosis": false,
      "lifestyle_assessment": true,
      "nutritional_consultation": false
    },
    "treatments_and_therapies": {
      "shirodhara": false,
      "shiro_abhyanga": false,
      "herbal_head_therapy": false,
      "abhyanga": false,
      "synchronised_abhyanga": false,
      "pinda_sweda": false,
      "udwardhana": false,
      "herbal_steam_bath": false,
      "sarvanga_dhara": false,
      "kati_basti": false,
      "greeva_basti": false,
      "janu_basti": false,
      "panchakarma": false,
      "vamana": false,
      "virechana": false,
      "basti": false,
      "nasya": false,
      "rakta_moksha": false
    },
    "segment_scores": {
      "holistic_healing_and_mindfulness_seekers": 5,
      "wellness_adventurers_and_nature_enthusiasts": 5,
      "luxury_rejuvenation_and_spa_retreaters": 4,
      "digital_detox_and_mental_wellness_travelers": 5,
      "cultural_and_ancestral_wellness_explorers": 5
    },
    "data_confidence": "High"
  },
  {
    "id": 39388506,
    "name": "Kirana - A Santani Villa",
    "city": "Bentota",
    "district": "",
    "rating": 4,
    "images": ['https://lh3.googleusercontent.com/gps-cs-s/AHRPTWl-dzBRLfKe9tH55bubb8osEcRKKfDGalPM9UiFbhTTwQfV7FViFDHTAGqMnrjA12CCZsVTPQZe1467nR93foiAAN8beJVIZh2yxDOAGvYOqa9ArXd17wfSV8_Njx42JCfd0V-zwMQcOmDb=s680-w680-h510-rw'],
    "primary_wellness_focus": "Wellness Retreat / Rejuvenation",
    "wellness_treatment_types": [
      "Relaxation",
      "Detox",
      "Burnout Recovery",
      "Mental Wellness",
      "Yoga Retreat",
      "Meditation Retreat"
    ],
    "wellnessPackages": [
      "Spa Retreat",
      "Detox & Clensing Program",
      "Ayurveda & Holistic Healing",
      "Yoga & Meditation Center",
      "Rejuvenation & Burnout Recovery",
      "Nature Wellness and Eco Retreat",
      "Coastal Wellness & Spa"
    ],
    "hotel_Category": [
      "Luxury",
      "Boutique Luxury"
    ],
    "links": {
      "official_website": "",
      "agoda_source_url": "https://www.agoda.com/partners/partnersearch.aspx?hid=39388506"
    },
    "property_features": {
      "adults_only": false,
      "family_friendly": false,
      "sustainability_certification": false,
      "primary_wellness_focus_property": true
    },
    "facilities": {
      "ayurveda_center": false,
      "spa": false,
      "yoga_pavilion": true,
      "meditation_hall": true,
      "fitness_center": false,
      "infinity_pool": false,
      "hydrotherapy_pool": false,
      "sauna": false,
      "steam_room": false,
      "jacuzzi": false,
      "salt_therapy_room": false,
      "wellness_library": false,
      "healing_garden": false,
      "herbal_garden": false,
      "walking_trails": false,
      "forest_bathing_area": false,
      "beachfront_wellness_space": true,
      "tea_plantation_walks": false
    },
    "activities_and_programs": {
      "outdoor_yoga_deck": true,
      "private_consultation_rooms": false,
      "sunrise_yoga": true,
      "sunset_yoga": true,
      "meditation_sessions": true,
      "breathwork": false,
      "mindfulness_workshops": true,
      "sound_healing": false,
      "chanting_sessions": false,
      "tai_chi": false,
      "qigong": false,
      "nature_walks": false,
      "forest_bathing": false,
      "bird_watching": false,
      "cooking_classes": false,
      "wellness_talks": false,
      "digital_detox_programs": true
    },
    "consultations_and_assessments": {
      "ayurvedic_doctor_consultation": false,
      "pulse_diagnosis": false,
      "lifestyle_assessment": false,
      "nutritional_consultation": false
    },
    "treatments_and_therapies": {
      "shirodhara": false,
      "shiro_abhyanga": false,
      "herbal_head_therapy": false,
      "abhyanga": false,
      "synchronised_abhyanga": false,
      "pinda_sweda": false,
      "udwardhana": false,
      "herbal_steam_bath": false,
      "sarvanga_dhara": false,
      "kati_basti": false,
      "greeva_basti": false,
      "janu_basti": false,
      "panchakarma": false,
      "vamana": false,
      "virechana": false,
      "basti": false,
      "nasya": false,
      "rakta_moksha": false
    },
    "segment_scores": {
      "holistic_healing_and_mindfulness_seekers": 5,
      "wellness_adventurers_and_nature_enthusiasts": 2,
      "luxury_rejuvenation_and_spa_retreaters": 5,
      "digital_detox_and_mental_wellness_travelers": 5,
      "cultural_and_ancestral_wellness_explorers": 2
    },
    "data_confidence": "Low"
  },
  {
    "id": 39691897,
    "name": "Heritance Ayurveda - All Meals and Treatments",
    "city": "Beruwala",
    "district": "Kalutara",
    "rating": 5,
    "images": ['https://pix8.agoda.net/hotelImages/39691897/-1/c530929b2573b0e89e64db8f5600bf03.jpg?va=1&ce=0&s=600x'],
    "primary_wellness_focus": "Ayurveda / Holistic Healing",
    "wellness_treatment_types": [
      "Stress Relief",
      "Relaxation",
      "Rejuvenation",
      "Weight Loss",
      "Detox",
      "Panchakarma Program",
      "Mental Wellness",
      "Yoga Retreat"
    ],
    "wellnessPackages": [
      "Spa Retreat",
      "Detox & Clensing Program",
      "Ayurveda & Holistic Healing",
      "Yoga & Meditation Center",
      "Rejuvenation & Burnout Recovery",
      "Medical Wellness",
      "Coastal Wellness & Spa"
    ],
    "hotel_Category": [
      "Luxury",
      "Boutique Luxury"
    ],
    "links": {
      "official_website": "https://www.heritancehotels.com/ayurveda/",
      "agoda_source_url": "https://www.agoda.com/partners/partnersearch.aspx?hid=39691897"
    },
    "property_features": {
      "adults_only": false,
      "family_friendly": false,
      "sustainability_certification": false,
      "primary_wellness_focus_property": true
    },
    "facilities": {
      "ayurveda_center": true,
      "spa": true,
      "yoga_pavilion": true,
      "meditation_hall": false,
      "fitness_center": false,
      "infinity_pool": false,
      "hydrotherapy_pool": false,
      "sauna": false,
      "steam_room": true,
      "jacuzzi": false,
      "salt_therapy_room": false,
      "wellness_library": false,
      "healing_garden": false,
      "herbal_garden": true,
      "walking_trails": false,
      "forest_bathing_area": false,
      "beachfront_wellness_space": true,
      "tea_plantation_walks": false
    },
    "activities_and_programs": {
      "outdoor_yoga_deck": true,
      "private_consultation_rooms": true,
      "sunrise_yoga": true,
      "sunset_yoga": true,
      "meditation_sessions": false,
      "breathwork": false,
      "mindfulness_workshops": false,
      "sound_healing": false,
      "chanting_sessions": false,
      "tai_chi": false,
      "qigong": false,
      "nature_walks": false,
      "forest_bathing": false,
      "bird_watching": false,
      "cooking_classes": false,
      "wellness_talks": true,
      "digital_detox_programs": false
    },
    "consultations_and_assessments": {
      "ayurvedic_doctor_consultation": true,
      "pulse_diagnosis": true,
      "lifestyle_assessment": true,
      "nutritional_consultation": true
    },
    "treatments_and_therapies": {
      "shirodhara": true,
      "shiro_abhyanga": true,
      "herbal_head_therapy": true,
      "abhyanga": true,
      "synchronised_abhyanga": false,
      "pinda_sweda": false,
      "udwardhana": false,
      "herbal_steam_bath": true,
      "sarvanga_dhara": false,
      "kati_basti": false,
      "greeva_basti": false,
      "janu_basti": false,
      "panchakarma": true,
      "vamana": false,
      "virechana": true,
      "basti": true,
      "nasya": true,
      "rakta_moksha": false
    },
    "segment_scores": {
      "holistic_healing_and_mindfulness_seekers": 5,
      "wellness_adventurers_and_nature_enthusiasts": 2,
      "luxury_rejuvenation_and_spa_retreaters": 2,
      "digital_detox_and_mental_wellness_travelers": 4,
      "cultural_and_ancestral_wellness_explorers": 4
    },
    "data_confidence": "High"
  },
  {
    "id": 44875952,
    "name": "Celestia Ayurveda Resort",
    "city": "Bentota",
    "district": "Galle",
    "rating": 5,
    "images": ['https://q-xx.bstatic.com/xdata/images/hotel/max1024x768/514363334.jpg?k=99ecfe4f80799aeae532e5fcf9263c5bebe4caa5417869924484838eda0dda07&o=&s=1024x'],
    "primary_wellness_focus": "Ayurveda / Holistic Healing",
    "wellness_treatment_types": [
      "Stress Relief",
      "Relaxation",
      "Rejuvenation",
      "Weight Loss",
      "Detox",
      "Panchakarma Program",
      "Mental Wellness",
      "Yoga Retreat"
    ],
    "wellnessPackages": [
      "Spa Retreat",
      "Detox & Clensing Program",
      "Ayurveda & Holistic Healing",
      "Yoga & Meditation Center",
      "Rejuvenation & Burnout Recovery"
    ],
    "hotel_Category": [
      "Luxury",
      "Boutique Luxury"
    ],
    "links": {
      "official_website": "https://www.celestiaresort.com/",
      "agoda_source_url": "https://www.agoda.com/partners/partnersearch.aspx?hid=44875952"
    },
    "property_features": {
      "adults_only": false,
      "family_friendly": false,
      "sustainability_certification": false,
      "primary_wellness_focus_property": true
    },
    "facilities": {
      "ayurveda_center": true,
      "spa": true,
      "yoga_pavilion": true,
      "meditation_hall": false,
      "fitness_center": false,
      "infinity_pool": true,
      "hydrotherapy_pool": false,
      "sauna": false,
      "steam_room": true,
      "jacuzzi": false,
      "salt_therapy_room": false,
      "wellness_library": false,
      "healing_garden": false,
      "herbal_garden": true,
      "walking_trails": true,
      "forest_bathing_area": true,
      "beachfront_wellness_space": true,
      "tea_plantation_walks": false
    },
    "activities_and_programs": {
      "outdoor_yoga_deck": true,
      "private_consultation_rooms": true,
      "sunrise_yoga": true,
      "sunset_yoga": true,
      "meditation_sessions": false,
      "breathwork": false,
      "mindfulness_workshops": false,
      "sound_healing": false,
      "chanting_sessions": false,
      "tai_chi": false,
      "qigong": false,
      "nature_walks": true,
      "forest_bathing": true,
      "bird_watching": true,
      "cooking_classes": true,
      "wellness_talks": true,
      "digital_detox_programs": false
    },
    "consultations_and_assessments": {
      "ayurvedic_doctor_consultation": true,
      "pulse_diagnosis": true,
      "lifestyle_assessment": true,
      "nutritional_consultation": true
    },
    "treatments_and_therapies": {
      "shirodhara": true,
      "shiro_abhyanga": true,
      "herbal_head_therapy": true,
      "abhyanga": true,
      "synchronised_abhyanga": false,
      "pinda_sweda": false,
      "udwardhana": false,
      "herbal_steam_bath": true,
      "sarvanga_dhara": false,
      "kati_basti": false,
      "greeva_basti": false,
      "janu_basti": false,
      "panchakarma": true,
      "vamana": false,
      "virechana": true,
      "basti": true,
      "nasya": true,
      "rakta_moksha": false
    },
    "segment_scores": {
      "holistic_healing_and_mindfulness_seekers": 5,
      "wellness_adventurers_and_nature_enthusiasts": 5,
      "luxury_rejuvenation_and_spa_retreaters": 5,
      "digital_detox_and_mental_wellness_travelers": 5,
      "cultural_and_ancestral_wellness_explorers": 4
    },
    "data_confidence": "High"
  },
  {
    "id": 47663130,
    "name": "Amuna Ayurveda and Wellness Retreat",
    "city": "Sigiriya",
    "district": "Matale",
    "rating": 4,
    "images": [
      "http://pix3.agoda.net/hotelimages/47663130/-1/cc636878370464262cdb05dcb5699889.jpg?s=312x&ce=0",
      "http://pix4.agoda.net/hotelimages/47663130/941284982/7c34a8dc33d00c639f586122b994dad6.jpg?s=312x&ce=0",
      "http://pix2.agoda.net/hotelimages/47663130/0/1f4ddb458e124c82071c001e1ea0ed12.jpg?s=312x&ce=0",
      "http://pix2.agoda.net/hotelimages/47663130/0/71137f3e7f32bd51d6966f2d69450422.png?s=312x&ce=0",
      "http://pix3.agoda.net/hotelimages/47663130/0/d396b34084f79e0783393c230dfe7b9b.jpg?s=312x&ce=0"
    ],
    "primary_wellness_focus": "Ayurveda / Holistic Healing",
    "wellness_treatment_types": [
      "Stress Relief",
      "Relaxation",
      "Rejuvenation",
      "Weight Loss",
      "Detox",
      "Panchakarma Program",
      "Burnout Recovery",
      "Mental Wellness",
      "Yoga Retreat",
      "Meditation Retreat"
    ],
    "wellnessPackages": [
      "Spa Retreat",
      "Detox & Clensing Program",
      "Ayurveda & Holistic Healing",
      "Yoga & Meditation Center",
      "Rejuvenation & Burnout Recovery",
      "Nature Wellness and Eco Retreat"
    ],
    "hotel_Category": [
      "Boutique",
      "Eco Wellness"
    ],
    "links": {
      "official_website": "https://www.amuna.lk/",
      "agoda_source_url": "https://www.agoda.com/partners/partnersearch.aspx?hid=47663130"
    },
    "property_features": {
      "adults_only": false,
      "family_friendly": false,
      "sustainability_certification": false,
      "primary_wellness_focus_property": true
    },
    "facilities": {
      "ayurveda_center": true,
      "spa": true,
      "yoga_pavilion": true,
      "meditation_hall": true,
      "fitness_center": false,
      "infinity_pool": false,
      "hydrotherapy_pool": false,
      "sauna": false,
      "steam_room": true,
      "jacuzzi": false,
      "salt_therapy_room": false,
      "wellness_library": false,
      "healing_garden": false,
      "herbal_garden": true,
      "walking_trails": true,
      "forest_bathing_area": true,
      "beachfront_wellness_space": false,
      "tea_plantation_walks": false
    },
    "activities_and_programs": {
      "outdoor_yoga_deck": true,
      "private_consultation_rooms": true,
      "sunrise_yoga": true,
      "sunset_yoga": true,
      "meditation_sessions": true,
      "breathwork": false,
      "mindfulness_workshops": true,
      "sound_healing": false,
      "chanting_sessions": false,
      "tai_chi": false,
      "qigong": false,
      "nature_walks": true,
      "forest_bathing": true,
      "bird_watching": true,
      "cooking_classes": false,
      "wellness_talks": true,
      "digital_detox_programs": true
    },
    "consultations_and_assessments": {
      "ayurvedic_doctor_consultation": true,
      "pulse_diagnosis": true,
      "lifestyle_assessment": true,
      "nutritional_consultation": true
    },
    "treatments_and_therapies": {
      "shirodhara": true,
      "shiro_abhyanga": true,
      "herbal_head_therapy": true,
      "abhyanga": true,
      "synchronised_abhyanga": false,
      "pinda_sweda": false,
      "udwardhana": false,
      "herbal_steam_bath": true,
      "sarvanga_dhara": false,
      "kati_basti": false,
      "greeva_basti": false,
      "janu_basti": false,
      "panchakarma": true,
      "vamana": false,
      "virechana": true,
      "basti": true,
      "nasya": true,
      "rakta_moksha": false
    },
    "segment_scores": {
      "holistic_healing_and_mindfulness_seekers": 5,
      "wellness_adventurers_and_nature_enthusiasts": 5,
      "luxury_rejuvenation_and_spa_retreaters": 2,
      "digital_detox_and_mental_wellness_travelers": 5,
      "cultural_and_ancestral_wellness_explorers": 5
    },
    "data_confidence": "High"
  },
  {
    "id": 58964457,
    "name": "Anasa Wellness Resort",
    "city": "Ella",
    "district": "",
    "rating": 5,
    "images": ['https://pix8.agoda.net/hotelImages/38271653/0/d895420cc550bf802767902884f5b3b7.jpeg?va=1&ce=0&s=1024x'],
    "primary_wellness_focus": "Wellness Retreat / Rejuvenation",
    "wellness_treatment_types": [
      "Relaxation",
      "Rejuvenation",
      "Burnout Recovery",
      "Mental Wellness",
      "Yoga Retreat",
      "Meditation Retreat"
    ],
    "wellnessPackages": [
      "Spa Retreat",
      "Detox & Clensing Program",
      "Ayurveda & Holistic Healing",
      "Yoga & Meditation Center",
      "Rejuvenation & Burnout Recovery",
      "Nature Wellness and Eco Retreat"
    ],
    "hotel_Category": [
      "Luxury",
      "Boutique Luxury"
    ],
    "links": {
      "official_website": "https://www.anasawellnessresort.com/",
      "agoda_source_url": "https://www.agoda.com/partners/partnersearch.aspx?hid=58964457"
    },
    "property_features": {
      "adults_only": false,
      "family_friendly": false,
      "sustainability_certification": false,
      "primary_wellness_focus_property": true
    },
    "facilities": {
      "ayurveda_center": false,
      "spa": true,
      "yoga_pavilion": true,
      "meditation_hall": true,
      "fitness_center": false,
      "infinity_pool": false,
      "hydrotherapy_pool": false,
      "sauna": false,
      "steam_room": false,
      "jacuzzi": false,
      "salt_therapy_room": false,
      "wellness_library": false,
      "healing_garden": false,
      "herbal_garden": false,
      "walking_trails": true,
      "forest_bathing_area": true,
      "beachfront_wellness_space": false,
      "tea_plantation_walks": true
    },
    "activities_and_programs": {
      "outdoor_yoga_deck": true,
      "private_consultation_rooms": true,
      "sunrise_yoga": true,
      "sunset_yoga": true,
      "meditation_sessions": true,
      "breathwork": false,
      "mindfulness_workshops": true,
      "sound_healing": false,
      "chanting_sessions": false,
      "tai_chi": false,
      "qigong": false,
      "nature_walks": true,
      "forest_bathing": true,
      "bird_watching": true,
      "cooking_classes": false,
      "wellness_talks": true,
      "digital_detox_programs": false
    },
    "consultations_and_assessments": {
      "ayurvedic_doctor_consultation": false,
      "pulse_diagnosis": false,
      "lifestyle_assessment": true,
      "nutritional_consultation": false
    },
    "treatments_and_therapies": {
      "shirodhara": false,
      "shiro_abhyanga": false,
      "herbal_head_therapy": false,
      "abhyanga": false,
      "synchronised_abhyanga": false,
      "pinda_sweda": false,
      "udwardhana": false,
      "herbal_steam_bath": false,
      "sarvanga_dhara": false,
      "kati_basti": false,
      "greeva_basti": false,
      "janu_basti": false,
      "panchakarma": false,
      "vamana": false,
      "virechana": false,
      "basti": false,
      "nasya": false,
      "rakta_moksha": false
    },
    "segment_scores": {
      "holistic_healing_and_mindfulness_seekers": 5,
      "wellness_adventurers_and_nature_enthusiasts": 2,
      "luxury_rejuvenation_and_spa_retreaters": 4,
      "digital_detox_and_mental_wellness_travelers": 5,
      "cultural_and_ancestral_wellness_explorers": 2
    },
    "data_confidence": "High"
  },
  {
    "id": 60750220,
    "name": "Ayurvedic Lanka Wellness Hotel",
    "city": "Sigiriya",
    "district": "Matale",
    "rating": 3,
    "images": [
      "http://pix5.agoda.net/hotelimages/60750220/0/215e158f0aee04009771fdf85f646a3a.jpg?s=312x&ce=0",
      "http://pix2.agoda.net/hotelimages/60750220/0/a0187b657fd24898a6d6a29f275e1b91.jpg?s=312x&ce=0",
      "http://pix1.agoda.net/hotelimages/60750220/0/7008aea53eda54ee8f6f00cc55d758c1.jpg?s=312x&ce=0",
      "http://pix4.agoda.net/hotelimages/60750220/0/3f08b0c8b519025dbcd75d7d2d276cd3.jpg?s=312x&ce=0",
      "http://pix5.agoda.net/hotelimages/60750220/0/b8f772962788e46e8b4e1b68c5615d2a.jpg?s=312x&ce=0"
    ],
    "primary_wellness_focus": "Ayurveda / Holistic Healing",
    "wellness_treatment_types": [
      "Stress Relief",
      "Relaxation",
      "Rejuvenation",
      "Weight Loss",
      "Detox",
      "Panchakarma Program",
      "Burnout Recovery",
      "Mental Wellness",
      "Yoga Retreat",
      "Meditation Retreat"
    ],
    "wellnessPackages": [
      "Detox & Clensing Program",
      "Ayurveda & Holistic Healing",
      "Yoga & Meditation Center",
      "Rejuvenation & Burnout Recovery",
      "Nature Wellness and Eco Retreat"
    ],
    "hotel_Category": [
      "Wellness Resort"
    ],
    "links": {
      "official_website": "https://ayurvediclanka.com/",
      "agoda_source_url": "https://www.agoda.com/partners/partnersearch.aspx?hid=60750220"
    },
    "property_features": {
      "adults_only": false,
      "family_friendly": false,
      "sustainability_certification": false,
      "primary_wellness_focus_property": true
    },
    "facilities": {
      "ayurveda_center": true,
      "spa": true,
      "yoga_pavilion": true,
      "meditation_hall": true,
      "fitness_center": false,
      "infinity_pool": false,
      "hydrotherapy_pool": false,
      "sauna": false,
      "steam_room": true,
      "jacuzzi": false,
      "salt_therapy_room": false,
      "wellness_library": false,
      "healing_garden": false,
      "herbal_garden": true,
      "walking_trails": true,
      "forest_bathing_area": true,
      "beachfront_wellness_space": false,
      "tea_plantation_walks": false
    },
    "activities_and_programs": {
      "outdoor_yoga_deck": true,
      "private_consultation_rooms": true,
      "sunrise_yoga": true,
      "sunset_yoga": true,
      "meditation_sessions": true,
      "breathwork": false,
      "mindfulness_workshops": true,
      "sound_healing": false,
      "chanting_sessions": false,
      "tai_chi": false,
      "qigong": false,
      "nature_walks": true,
      "forest_bathing": true,
      "bird_watching": true,
      "cooking_classes": false,
      "wellness_talks": true,
      "digital_detox_programs": false
    },
    "consultations_and_assessments": {
      "ayurvedic_doctor_consultation": true,
      "pulse_diagnosis": true,
      "lifestyle_assessment": true,
      "nutritional_consultation": true
    },
    "treatments_and_therapies": {
      "shirodhara": true,
      "shiro_abhyanga": true,
      "herbal_head_therapy": true,
      "abhyanga": true,
      "synchronised_abhyanga": false,
      "pinda_sweda": false,
      "udwardhana": false,
      "herbal_steam_bath": true,
      "sarvanga_dhara": false,
      "kati_basti": false,
      "greeva_basti": false,
      "janu_basti": false,
      "panchakarma": true,
      "vamana": false,
      "virechana": true,
      "basti": true,
      "nasya": true,
      "rakta_moksha": false
    },
    "segment_scores": {
      "holistic_healing_and_mindfulness_seekers": 5,
      "wellness_adventurers_and_nature_enthusiasts": 5,
      "luxury_rejuvenation_and_spa_retreaters": 2,
      "digital_detox_and_mental_wellness_travelers": 5,
      "cultural_and_ancestral_wellness_explorers": 5
    },
    "data_confidence": "High"
  },
  {
    "id": 61712047,
    "name": "Luxor Kirindi Ella Resort & Spa",
    "city": "Bandarawela",
    "district": "Badulla",
    "rating": 4,
    "images": ['https://pix8.agoda.net/hotelImages/61712047/0/055fc83b1862f067fbe38c15ad66804d.png?va=1&ce=3&s=1024x'],
    "primary_wellness_focus": "Spa / Leisure Wellness",
    "wellness_treatment_types": [
      "Relaxation",
      "Rejuvenation"
    ],
    "wellnessPackages": [
      "Spa Retreat",
      "Detox & Clensing Program",
      "Ayurveda & Holistic Healing",
      "Yoga & Meditation Center",
      "Rejuvenation & Burnout Recovery",
      "Nature Wellness and Eco Retreat"
    ],
    "hotel_Category": [
      "Hotel",
      "Resort"
    ],
    "links": {
      "official_website": "",
      "agoda_source_url": "https://www.agoda.com/partners/partnersearch.aspx?hid=61712047"
    },
    "property_features": {
      "adults_only": false,
      "family_friendly": false,
      "sustainability_certification": false,
      "primary_wellness_focus_property": true
    },
    "facilities": {
      "ayurveda_center": false,
      "spa": true,
      "yoga_pavilion": false,
      "meditation_hall": false,
      "fitness_center": false,
      "infinity_pool": false,
      "hydrotherapy_pool": false,
      "sauna": false,
      "steam_room": false,
      "jacuzzi": false,
      "salt_therapy_room": false,
      "wellness_library": false,
      "healing_garden": false,
      "herbal_garden": false,
      "walking_trails": true,
      "forest_bathing_area": true,
      "beachfront_wellness_space": false,
      "tea_plantation_walks": true
    },
    "activities_and_programs": {
      "outdoor_yoga_deck": false,
      "private_consultation_rooms": true,
      "sunrise_yoga": false,
      "sunset_yoga": false,
      "meditation_sessions": false,
      "breathwork": false,
      "mindfulness_workshops": false,
      "sound_healing": false,
      "chanting_sessions": false,
      "tai_chi": false,
      "qigong": false,
      "nature_walks": true,
      "forest_bathing": true,
      "bird_watching": true,
      "cooking_classes": false,
      "wellness_talks": false,
      "digital_detox_programs": false
    },
    "consultations_and_assessments": {
      "ayurvedic_doctor_consultation": false,
      "pulse_diagnosis": false,
      "lifestyle_assessment": false,
      "nutritional_consultation": false
    },
    "treatments_and_therapies": {
      "shirodhara": false,
      "shiro_abhyanga": false,
      "herbal_head_therapy": false,
      "abhyanga": false,
      "synchronised_abhyanga": false,
      "pinda_sweda": false,
      "udwardhana": false,
      "herbal_steam_bath": false,
      "sarvanga_dhara": false,
      "kati_basti": false,
      "greeva_basti": false,
      "janu_basti": false,
      "panchakarma": false,
      "vamana": false,
      "virechana": false,
      "basti": false,
      "nasya": false,
      "rakta_moksha": false
    },
    "segment_scores": {
      "holistic_healing_and_mindfulness_seekers": 3,
      "wellness_adventurers_and_nature_enthusiasts": 2,
      "luxury_rejuvenation_and_spa_retreaters": 5,
      "digital_detox_and_mental_wellness_travelers": 4,
      "cultural_and_ancestral_wellness_explorers": 2
    },
    "data_confidence": "Low"
  },
  {
    "id": 63453010,
    "name": "Ayurvie Weligama -  Thema Collection",
    "city": "Weligama",
    "district": "Matara",
    "rating": 5,
    "images": [
      "http://pix4.agoda.net/hotelimages/63453010/0/e8e236118b7380c7d2d998351ffb1869.jpg?s=312x&ce=0",
      "http://pix4.agoda.net/hotelimages/63453010/0/4171eb3d0f7d074f70479550d541db09.jpg?s=312x&ce=0",
      "http://pix5.agoda.net/hotelimages/63453010/0/9761b0323cae94c4294822e7f14b1141.jpg?s=312x&ce=0",
      "http://pix5.agoda.net/hotelimages/63453010/0/cba7e47da1515876b5a78f2a829210b0.jpg?s=312x&ce=0"
    ],
    "primary_wellness_focus": "Ayurveda / Holistic Healing",
    "wellness_treatment_types": [
      "Stress Relief",
      "Relaxation",
      "Rejuvenation",
      "Weight Loss",
      "Detox",
      "Panchakarma Program",
      "Mental Wellness",
      "Yoga Retreat"
    ],
    "wellnessPackages": [
      "Spa Retreat",
      "Detox & Clensing Program",
      "Ayurveda & Holistic Healing",
      "Yoga & Meditation Center",
      "Rejuvenation & Burnout Recovery",
      "Coastal Wellness & Spa"
    ],
    "hotel_Category": [
      "Luxury",
      "Boutique Luxury"
    ],
    "links": {
      "official_website": "https://www.themacollection.com/ayurvie-weligama/",
      "agoda_source_url": "https://www.agoda.com/partners/partnersearch.aspx?hid=63453010"
    },
    "property_features": {
      "adults_only": false,
      "family_friendly": false,
      "sustainability_certification": false,
      "primary_wellness_focus_property": true
    },
    "facilities": {
      "ayurveda_center": true,
      "spa": false,
      "yoga_pavilion": true,
      "meditation_hall": false,
      "fitness_center": false,
      "infinity_pool": false,
      "hydrotherapy_pool": false,
      "sauna": false,
      "steam_room": true,
      "jacuzzi": false,
      "salt_therapy_room": false,
      "wellness_library": false,
      "healing_garden": false,
      "herbal_garden": true,
      "walking_trails": false,
      "forest_bathing_area": false,
      "beachfront_wellness_space": true,
      "tea_plantation_walks": false
    },
    "activities_and_programs": {
      "outdoor_yoga_deck": true,
      "private_consultation_rooms": true,
      "sunrise_yoga": true,
      "sunset_yoga": true,
      "meditation_sessions": false,
      "breathwork": false,
      "mindfulness_workshops": false,
      "sound_healing": false,
      "chanting_sessions": false,
      "tai_chi": false,
      "qigong": false,
      "nature_walks": false,
      "forest_bathing": false,
      "bird_watching": false,
      "cooking_classes": false,
      "wellness_talks": false,
      "digital_detox_programs": false
    },
    "consultations_and_assessments": {
      "ayurvedic_doctor_consultation": true,
      "pulse_diagnosis": true,
      "lifestyle_assessment": true,
      "nutritional_consultation": true
    },
    "treatments_and_therapies": {
      "shirodhara": true,
      "shiro_abhyanga": true,
      "herbal_head_therapy": true,
      "abhyanga": true,
      "synchronised_abhyanga": false,
      "pinda_sweda": false,
      "udwardhana": false,
      "herbal_steam_bath": true,
      "sarvanga_dhara": false,
      "kati_basti": false,
      "greeva_basti": false,
      "janu_basti": false,
      "panchakarma": true,
      "vamana": false,
      "virechana": true,
      "basti": true,
      "nasya": true,
      "rakta_moksha": false
    },
    "segment_scores": {
      "holistic_healing_and_mindfulness_seekers": 2,
      "wellness_adventurers_and_nature_enthusiasts": 2,
      "luxury_rejuvenation_and_spa_retreaters": 2,
      "digital_detox_and_mental_wellness_travelers": 2,
      "cultural_and_ancestral_wellness_explorers": 2
    },
    "data_confidence": "High"
  },
  {
    "id": 80170875,
    "name": "Aetos wellness -Tangalle",
    "city": "Tangalle",
    "district": "Hambantota",
    "rating": 5,
    "images": [
      "http://pix2.agoda.net/hotelimages/80170875/0/4dfb46e5acc93286ad6e69f141633b2f.jpg?s=312x&ce=2",
      "http://pix1.agoda.net/hotelimages/80170875/0/51e8e54df2e133d5a64015085f063d7c.jpg?s=312x&ce=2",
      "http://pix5.agoda.net/hotelimages/80170875/0/f14eecba5999c6de4e620a67512095cd.jpg?s=312x&ce=2",
      "http://pix3.agoda.net/hotelimages/80170875/0/d71fda4c284acebce6ae74305aa5614c.jpg?s=312x&ce=2",
      "http://pix5.agoda.net/hotelimages/80170875/0/7dcbc2332e77c6fccc99afd74a0b2594.jpg?s=312x&ce=2"
    ],
    "primary_wellness_focus": "Wellness Retreat / Rejuvenation",
    "wellness_treatment_types": [
      "Relaxation",
      "Rejuvenation",
      "Burnout Recovery",
      "Mental Wellness",
      "Yoga Retreat",
      "Meditation Retreat"
    ],
    "wellnessPackages": [
      "Spa Retreat",
      "Detox & Clensing Program",
      "Ayurveda & Holistic Healing",
      "Yoga & Meditation Center",
      "Rejuvenation & Burnout Recovery",
      "Nature Wellness and Eco Retreat"
    ],
    "hotel_Category": [
      "Luxury",
      "Boutique Luxury"
    ],
    "links": {
      "official_website": "",
      "agoda_source_url": "https://www.agoda.com/partners/partnersearch.aspx?hid=80170875"
    },
    "property_features": {
      "adults_only": false,
      "family_friendly": false,
      "sustainability_certification": false,
      "primary_wellness_focus_property": true
    },
    "facilities": {
      "ayurveda_center": false,
      "spa": true,
      "yoga_pavilion": true,
      "meditation_hall": true,
      "fitness_center": false,
      "infinity_pool": false,
      "hydrotherapy_pool": false,
      "sauna": false,
      "steam_room": false,
      "jacuzzi": false,
      "salt_therapy_room": false,
      "wellness_library": false,
      "healing_garden": false,
      "herbal_garden": false,
      "walking_trails": false,
      "forest_bathing_area": false,
      "beachfront_wellness_space": true,
      "tea_plantation_walks": false
    },
    "activities_and_programs": {
      "outdoor_yoga_deck": true,
      "private_consultation_rooms": true,
      "sunrise_yoga": true,
      "sunset_yoga": true,
      "meditation_sessions": true,
      "breathwork": false,
      "mindfulness_workshops": true,
      "sound_healing": false,
      "chanting_sessions": false,
      "tai_chi": false,
      "qigong": false,
      "nature_walks": false,
      "forest_bathing": false,
      "bird_watching": false,
      "cooking_classes": false,
      "wellness_talks": true,
      "digital_detox_programs": false
    },
    "consultations_and_assessments": {
      "ayurvedic_doctor_consultation": false,
      "pulse_diagnosis": false,
      "lifestyle_assessment": true,
      "nutritional_consultation": false
    },
    "treatments_and_therapies": {
      "shirodhara": false,
      "shiro_abhyanga": false,
      "herbal_head_therapy": false,
      "abhyanga": false,
      "synchronised_abhyanga": false,
      "pinda_sweda": false,
      "udwardhana": false,
      "herbal_steam_bath": false,
      "sarvanga_dhara": false,
      "kati_basti": false,
      "greeva_basti": false,
      "janu_basti": false,
      "panchakarma": false,
      "vamana": false,
      "virechana": false,
      "basti": false,
      "nasya": false,
      "rakta_moksha": false
    },
    "segment_scores": {
      "holistic_healing_and_mindfulness_seekers": 5,
      "wellness_adventurers_and_nature_enthusiasts": 2,
      "luxury_rejuvenation_and_spa_retreaters": 2,
      "digital_detox_and_mental_wellness_travelers": 5,
      "cultural_and_ancestral_wellness_explorers": 2
    },
    "data_confidence": "Low"
  },
  {
    "id": 81520623,
    "name": "Rain Drops Wellness Villa Sinharaja",
    "city": "Kotapola",
    "district": "Matara",
    "rating": 3,
    "images": [
      "http://pix1.agoda.net/hotelimages/81520623/0/9d5c350b4dfda5e6759381149179daca.jpg?s=312x&ce=3",
      "http://pix5.agoda.net/hotelimages/81520623/1277065374/418c84fc99f92c962190ad04fd34df93.jpg?s=312x&ce=3",
      "http://pix1.agoda.net/hotelimages/81520623/0/70e63f16aea7f4c1da746cc94f6c65b9.jpg?s=312x&ce=3",
      "http://pix4.agoda.net/hotelimages/81520623/0/a3da80e64576f3ee28e35de1747a57f8.jpg?s=312x&ce=3",
      "http://pix4.agoda.net/hotelimages/81520623/0/821124a3c612ac479af0d4c79b97c757.jpg?s=312x&ce=3"
    ],
    "primary_wellness_focus": "Wellness Retreat / Rejuvenation",
    "wellness_treatment_types": [
      "Relaxation",
      "Rejuvenation",
      "Burnout Recovery",
      "Mental Wellness",
      "Yoga Retreat",
      "Meditation Retreat"
    ],
    "wellnessPackages": [
      "Spa Retreat",
      "Ayurveda & Holistic Healing",
      "Yoga & Meditation Center",
      "Rejuvenation & Burnout Recovery",
      "Nature Wellness and Eco Retreat"
    ],
    "hotel_Category": [
      "Boutique",
      "Eco Wellness"
    ],
    "links": {
      "official_website": "https://raindrops.lk/",
      "agoda_source_url": "https://www.agoda.com/partners/partnersearch.aspx?hid=81520623"
    },
    "property_features": {
      "adults_only": false,
      "family_friendly": false,
      "sustainability_certification": false,
      "primary_wellness_focus_property": true
    },
    "facilities": {
      "ayurveda_center": false,
      "spa": true,
      "yoga_pavilion": true,
      "meditation_hall": true,
      "fitness_center": false,
      "infinity_pool": false,
      "hydrotherapy_pool": false,
      "sauna": false,
      "steam_room": false,
      "jacuzzi": false,
      "salt_therapy_room": false,
      "wellness_library": false,
      "healing_garden": false,
      "herbal_garden": false,
      "walking_trails": true,
      "forest_bathing_area": true,
      "beachfront_wellness_space": false,
      "tea_plantation_walks": true
    },
    "activities_and_programs": {
      "outdoor_yoga_deck": true,
      "private_consultation_rooms": true,
      "sunrise_yoga": true,
      "sunset_yoga": true,
      "meditation_sessions": true,
      "breathwork": false,
      "mindfulness_workshops": true,
      "sound_healing": false,
      "chanting_sessions": false,
      "tai_chi": false,
      "qigong": false,
      "nature_walks": true,
      "forest_bathing": true,
      "bird_watching": true,
      "cooking_classes": false,
      "wellness_talks": true,
      "digital_detox_programs": false
    },
    "consultations_and_assessments": {
      "ayurvedic_doctor_consultation": false,
      "pulse_diagnosis": false,
      "lifestyle_assessment": true,
      "nutritional_consultation": false
    },
    "treatments_and_therapies": {
      "shirodhara": false,
      "shiro_abhyanga": false,
      "herbal_head_therapy": false,
      "abhyanga": false,
      "synchronised_abhyanga": false,
      "pinda_sweda": false,
      "udwardhana": false,
      "herbal_steam_bath": false,
      "sarvanga_dhara": false,
      "kati_basti": false,
      "greeva_basti": false,
      "janu_basti": false,
      "panchakarma": false,
      "vamana": false,
      "virechana": false,
      "basti": false,
      "nasya": false,
      "rakta_moksha": false
    },
    "segment_scores": {
      "holistic_healing_and_mindfulness_seekers": 5,
      "wellness_adventurers_and_nature_enthusiasts": 5,
      "luxury_rejuvenation_and_spa_retreaters": 2,
      "digital_detox_and_mental_wellness_travelers": 5,
      "cultural_and_ancestral_wellness_explorers": 2
    },
    "data_confidence": "High"
  },
  {
    "id": 82986319,
    "name": "Wellness Residencies",
    "city": "Colombo",
    "district": "Colombo",
    "rating": 5,
    "images": [
      "http://pix4.agoda.net/hotelimages/82986319/0/eb74b3404cd991cfca60fe150e8acce5.jpg?s=312x&ce=3",
      "http://pix4.agoda.net/hotelimages/82986319/0/ccc214ad03497852897da07efe6d22ce.jpg?s=312x&ce=3",
      "http://pix4.agoda.net/hotelimages/82986319/0/59b51e364e005af551111701b9fa9a29.jpg?s=312x&ce=3",
      "http://pix2.agoda.net/hotelimages/82986319/0/8501970c91e9fb3e766df15b969c2ae9.jpg?s=312x&ce=3",
      "http://pix2.agoda.net/hotelimages/82986319/0/5cce8e81af2a05d5830b0d93af9e196f.jpg?s=312x&ce=3"
    ],
    "primary_wellness_focus": "Wellness Retreat / Rejuvenation",
    "wellness_treatment_types": [
      "Relaxation",
      "Rejuvenation",
      "Burnout Recovery",
      "Mental Wellness",
      "Yoga Retreat",
      "Meditation Retreat"
    ],
    "wellnessPackages": [
      "Yoga & Meditation Center"
    ],
    "hotel_Category": [
      "Luxury",
      "Boutique Luxury"
    ],
    "links": {
      "official_website": "",
      "agoda_source_url": "https://www.agoda.com/partners/partnersearch.aspx?hid=82986319"
    },
    "property_features": {
      "adults_only": false,
      "family_friendly": false,
      "sustainability_certification": false,
      "primary_wellness_focus_property": true
    },
    "facilities": {
      "ayurveda_center": false,
      "spa": true,
      "yoga_pavilion": true,
      "meditation_hall": true,
      "fitness_center": false,
      "infinity_pool": false,
      "hydrotherapy_pool": false,
      "sauna": false,
      "steam_room": false,
      "jacuzzi": false,
      "salt_therapy_room": false,
      "wellness_library": false,
      "healing_garden": false,
      "herbal_garden": false,
      "walking_trails": false,
      "forest_bathing_area": false,
      "beachfront_wellness_space": false,
      "tea_plantation_walks": false
    },
    "activities_and_programs": {
      "outdoor_yoga_deck": true,
      "private_consultation_rooms": true,
      "sunrise_yoga": true,
      "sunset_yoga": true,
      "meditation_sessions": true,
      "breathwork": false,
      "mindfulness_workshops": true,
      "sound_healing": false,
      "chanting_sessions": false,
      "tai_chi": false,
      "qigong": false,
      "nature_walks": false,
      "forest_bathing": false,
      "bird_watching": false,
      "cooking_classes": false,
      "wellness_talks": true,
      "digital_detox_programs": false
    },
    "consultations_and_assessments": {
      "ayurvedic_doctor_consultation": false,
      "pulse_diagnosis": false,
      "lifestyle_assessment": true,
      "nutritional_consultation": false
    },
    "treatments_and_therapies": {
      "shirodhara": false,
      "shiro_abhyanga": false,
      "herbal_head_therapy": false,
      "abhyanga": false,
      "synchronised_abhyanga": false,
      "pinda_sweda": false,
      "udwardhana": false,
      "herbal_steam_bath": false,
      "sarvanga_dhara": false,
      "kati_basti": false,
      "greeva_basti": false,
      "janu_basti": false,
      "panchakarma": false,
      "vamana": false,
      "virechana": false,
      "basti": false,
      "nasya": false,
      "rakta_moksha": false
    },
    "segment_scores": {
      "holistic_healing_and_mindfulness_seekers": 5,
      "wellness_adventurers_and_nature_enthusiasts": 2,
      "luxury_rejuvenation_and_spa_retreaters": 2,
      "digital_detox_and_mental_wellness_travelers": 5,
      "cultural_and_ancestral_wellness_explorers": 2
    },
    "data_confidence": "Low"
  }

];



